import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { Parametros } from 'src/app/services/domain/services-domain';
import { StorageService } from 'src/app/services/storage.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { ConsultarDireccionEntidadRequest, ListarArchivoEntidadRequest, ListarAuditoriaRequest, ListarCuentasBancariasRequest, ListarEntidadesRequest, ListarHistorialRequest, ListarLimiteCreditoRequest, ListarUbigeosRequest, SincronizarEntidadSapRequest, TablaDireccionEntidad, TablaEntidadBloqueo, TransaccionEntidadBloqueoRequest, ValidarDocIdentidadRequest, ListarTipoCargaRequest, ListarZonaTransporteRequest, ListarServiciosProveedoresRequest, TablaEntidadTipoCarga, TablaEntidadDetalleServicio, TablaEntidadZonaTransporte } from '../../../domain/request/mantenimiento-request';
import { SelectItem } from 'primeng/api/selectitem';
import { ConfirmationService, MessageService } from 'primeng/api';
import { sunatRequest } from 'src/app/proforma/domain/request/proforma_request';
import { ListaCuentasBancarias, ListarEntidades } from '../../../domain/response/mantenimiento-response';
import { ComisionesRepository } from 'src/app/comisiones/domain/Comisiones-repository';
import { ListarTiposRequest } from 'src/app/statement-carrier/domain/request/statement-carrier-request';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';

import { UtilService } from 'src/app/services/util.service';
import { SoporteRepository } from 'src/app/soporte/domain/soporte.repository';
import { ListarTipoRequest } from 'src/app/soporte/domain/request/soporte_request';

@Component({
  selector: 'app-page-mant-proveedores',
  templateUrl: './page-mant-proveedores.component.html',
  styleUrls: ['./page-mant-proveedores.component.css'],
  providers: [MessageService],
  standalone: false
})
export class PageMantProveedoresComponent {

  constructor(
    private readonly mantcomercial: ComercialRepository,
    private readonly storage: StorageService,
    private util: UtilService,
    private readonly comisiones: ComisionesRepository,
    private readonly proformaService: ProformaRepository,
    private messageService: MessageService,
    private readonly router: Router,
    private readonly title: Title,
    private cdr: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
    private readonly soporte: SoporteRepository,
  ) { }

  codigoEntidad: number = 2
  fechaActual: Date = new Date();
  //FORMULARIOS PARA CADA SECCION
  group: FormGroup
  groupPoppupDG: FormGroup
  groupPoppupD: FormGroup
  groupPoppupB: FormGroup
  groupPS: FormGroup
  groupOD: FormGroup

  //DATATABLES
  dataTable: any[] = []
  dataTableCuentasBancarias: any[] = []
  dataTableServicios: any[] = []
  dtS: any[] = []
  TableZonaTransporte: any[] = []
  dtT: any[] = []

  defaultRowCuentasBancarias: ListaCuentasBancarias = {
    tipotran: null,
    entC_Codigo: null,
    tipO_TabBCO: null,
    tipO_CodBCO: null,
    tipO_BCO: null,
    encB_TipoCuenta: null,
    tipoCuenta: null,
    encB_NroCuentaSol: null,
    encB_NroCuentaDol: null,
  };

  dataTableLimiteCredito: any[] = []
  InsertLimCredito: any[] = []
  dataTableAuditoria: any[] = []
  dataTableArchivos: any[] = []
  dataTableDireccion: any[] = []
  dataTableHistorial: any[] = []

  //CONDICIONES
  visible: boolean
  juridica: boolean
  natural: boolean
  visiblebtn: boolean
  visiblenumdoc: boolean = true


  //LISTAS DROPDOWN
  ListaTodosTipoDoc: any[] = []
  ListaTodosBanco: SelectItem[] = []
  ListaTodosMoneda: SelectItem[] = []
  tipo: any[] = []
  sexo: any[] = []
  atributos: any[] = []
  tipocuenta: SelectItem[] = []
  formapago: SelectItem[] = []
  listPais: any[] = [];
  listDepartamento: any[] = [];
  listProvincia: any[] = [];
  listProvinciaO: any[] = [];
  listDistrito: any[] = [];
  listDistritoO: any[] = [];
  listaTodosCarga: any[] = [];
  listReg: any[] = [];
  activeIndex: number
  activeIndex2: number
  entcCod: number
  ListaTipoLimiteCredito: SelectItem[] = [];

  lineaNegocio: any[] = [
    { nombre: 'MANDATO', codigo: '001' },
    { nombre: 'EXPORTACIONES', codigo: '002' },
    { nombre: 'SERVICIO INTEGRADO LOCAL', codigo: '003' },
    { nombre: 'OTROS TRAFICOS', codigo: '004' },
    { nombre: 'ADMINISTRATIVO', codigo: '005' },
    { nombre: 'SEGUROS', codigo: '006' },
    { nombre: 'SERVICIO LOGISTICO INTEGRAL', codigo: '007' },
  ]

  metadataTable: newmetadate[] = [
    { title: 'Sincronizar SAP', field: '', inputType: 'buttonPersonalizado', icon: 'pi pi-user', loading: false, function: (row: any) => this.sincronizarSAP(row), style: { align: "center" } },
    { field: 'entC_Codigo', title: 'Código', inputType: 'text' }, { field: 'tipO_CodTDI', title: 'Tipo Doc. Iden.', inputType: 'text' },
    { field: 'entC_DocIden', title: 'N.I.T', inputType: 'text' }, { field: 'entC_RazonSocial', title: 'Nombre', inputType: 'text', style: { justify: "left" } },
    { field: 'entC_Activo', title: 'Activo', inputType: 'checkbox' }, { field: 'entC_EMail', title: 'Correo', inputType: 'text', style: { justify: "left" } },
    { field: 'entC_EmailReceptorFE', title: 'Correo Factura Electrónica', inputType: 'text', style: { justify: "left" } }, { field: 'entC_Telef1', title: 'Tel. Fijo', inputType: 'text' },
    { field: 'entC_Telef2', title: 'Tel. Móvil', inputType: 'text' }, { field: 'entC_CodSAP_C', title: 'Cliente SAP', inputType: 'text' },
    { field: 'entC_CodSAP_P', title: 'Proveedor SAP', inputType: 'text' }, { field: 'entC_FecActSAP', title: 'Sincronización SAP', inputType: 'datetime' },
    { field: 'audI_UsrCrea', title: 'Creado por', inputType: 'text' }, { field: 'audI_FecCrea', title: 'Fecha crea', inputType: 'datetime' },
    { field: 'audI_UsrMod', title: 'Modificado por', inputType: 'text' }, { field: 'audI_FecMod', title: 'Fecha mod.', inputType: 'datetime' }
  ]

  metadataTableCuentasBancarias: newmetadate[] = [
    { field: 'tipO_BCO', title: 'Banco', inputType: 'autocomplete', dropdown: this.ListaTodosBanco }, { field: 'tipoCuenta', title: 'Tipo de Cuenta', inputType: 'autocomplete', dropdown: this.tipocuenta },
    { field: 'encB_NroCuentaSol', title: 'Cuenta en S/.', inputType: 'text' }, { field: 'encB_NroCuentaDol', title: 'Cuenta en US$', inputType: 'text' }
  ]

  metadataTableZonaTransporte: newmetadate[] = [
    { field: 'departamento', title: 'Departamento', inputType: 'text' },
    { field: 'provincia', title: 'Provincia', inputType: 'text' },
    { field: 'distrito', title: 'Distrito', inputType: 'text' },
  ]

  metadataTableZonaTipoCarga: newmetadate[] = [
    { field: 'tipocarga', title: 'Tipo Carga', inputType: 'text' },
  ]

  mdtS: newmetadate[] = [
    { field: 'servicio', title: 'Nombre del Servicio', inputType: 'text', filterType: 'text' },
    { field: 'critico', title: 'Critico', inputType: 'checkboxEdit' }
  ]

  metadataTableAuditoria: newmetadate[] = [
    { field: 'operacion', title: 'Operación', inputType: 'text' }, { field: 'direccionip', title: 'Dirección IP', inputType: 'text' },
    { field: 'nombremaquina', title: 'Nombre Máquina', inputType: 'text' }, { field: 'nombreaplicacion', title: 'Nombre Aplicación', inputType: 'text' },
    { field: 'usuariosql', title: 'Usuario SQL', inputType: 'text' }, { field: 'usuarioaplicacion', title: 'Usuario Aplicación', inputType: 'text' },
    { field: 'fechamodificacion', title: 'Fecha Modificación', inputType: 'datetime' }, { field: 'codigoentidad', title: 'Código Entidad', inputType: 'text' },
    { field: 'docidentidad', title: 'Doc. Identidad', inputType: 'text' }, { field: 'codigodocidentidad', title: 'Código Doc. Iden.', inputType: 'text' },
    { field: 'numdocidentidad', title: 'Num. Doc. Identidad', inputType: 'text' }, { field: 'tipopersona', title: 'Tipo Persona', inputType: 'text' },
    { field: 'domiciliado', title: 'Domiciliado', inputType: 'checkbox' }, { field: 'nombres', title: 'Nombres', inputType: 'text' },
    { field: 'apellidopaterno', title: 'Ape. Paterno', inputType: 'text' }, { field: 'apellidomaterno', title: 'Ape. Materno', inputType: 'text' },
    { field: 'nombrecompleto', title: 'Nom. Completo', inputType: 'text' }, { field: 'nombrecomercial', title: 'Nom. Comercial', inputType: 'text' },
    { field: 'razonsocial', title: 'Razón Social', inputType: 'text' }, { field: 'activo', title: 'Activo', inputType: 'checkbox' },
    { field: 'fechanacimiento', title: 'Fec. Nacimiento', inputType: 'datetime' }, { field: 'fechaingreso', title: 'Fec. Ingreso', inputType: 'datetime' },
    { field: 'vip', title: 'VIP', inputType: 'checkbox' }, { field: 'notas', title: 'Notas', inputType: 'text' },
    { field: 'sexo', title: 'Sexo', inputType: 'text' }, { field: 'email', title: 'E-mail', inputType: 'text' },
    { field: 'email2', title: 'E-mail2', inputType: 'text' }, { field: 'web', title: 'Web', inputType: 'text' },
    { field: 'propio', title: 'Propio', inputType: 'checkbox' }, { field: 'telefono1', title: 'Teléfono 1', inputType: 'text' },
    { field: 'telefono2', title: 'Teléfono 2', inputType: 'text' }, { field: 'telefono3', title: 'Teléfono 3', inputType: 'text' },
    { field: 'telefono4', title: 'Teléfono 4', inputType: 'text' }, { field: 'beneficiario', title: 'Beneficiario', inputType: 'text' },
    { field: 'area', title: 'Área', inputType: 'text' }, { field: 'cargo', title: 'Cargo', inputType: 'text' },
    { field: 'cuentausuario', title: 'Cuenta Usuario', inputType: 'text' }, { field: 'pais', title: 'País', inputType: 'text' },
    { field: 'codigopais', title: 'Cod. País', inputType: 'text' }, { field: 'holding', title: 'Holding', inputType: 'text' },
    { field: 'codigoholding', title: 'Cod. Holding', inputType: 'text' }, { field: 'tipotarifa', title: 'Tipo Tarifa', inputType: 'text' },
    { field: 'codigotarifa', title: 'Cod. Tarifa', inputType: 'text' }, { field: 'prospecto', title: 'Prospecto', inputType: 'checkbox' },
    { field: 'rebate', title: 'Rebate', inputType: 'decimal' }, { field: 'moneda', title: 'Moneda', inputType: 'text' },
    { field: 'codigomoneda', title: 'Cod. Moneda', inputType: 'text' }, { field: 'tipodeposito', title: 'Tipo Depósito', inputType: 'text' },
    { field: 'codtipodeposito', title: 'Cod. Tipo Depósito', inputType: 'text' }, { field: 'tarja', title: 'Tarja', inputType: 'decimal' },
    { field: 'realizatarja', title: 'Realiza Tarja', inputType: 'checkbox' }, { field: 'diacredito', title: 'Día Crédito', inputType: 'int' },
    { field: 'fechacredito', title: 'Fec. Crédito', inputType: 'datetime' }, { field: 'codigoaduana', title: 'Cod. Aduana', inputType: 'text' },
    { field: 'observaciones', title: 'Observaciones', inputType: 'text' }, { field: 'cuenintersoles', title: 'Cuen. Inter. Soles', inputType: 'text' },
    { field: 'cueninterdolares', title: 'Cuen. Inter. Dólares', inputType: 'text' }, { field: 'cuendetraccion', title: 'Cuen. Detracción', inputType: 'text' },
    { field: 'serviciologistico', title: 'Servicio Logístico', inputType: 'checkbox' }, { field: 'ocultarshipper', title: 'Ocultar Shipper', inputType: 'checkbox' },
    { field: 'obserfinanzas', title: 'Obser. Finanzas', inputType: 'text' }, { field: 'otrostraficos', title: 'Otros Tráficos', inputType: 'checkbox' },
    { field: 'mandato', title: 'Mandato', inputType: 'checkbox' }, { field: 'sli', title: 'SLI', inputType: 'checkbox' },
    { field: 'exportacion', title: 'Exportación', inputType: 'checkbox' }, { field: 'emailfinanzas', title: 'E-mail Fnanzas', inputType: 'text' },
    { field: 'bloqueocliente', title: 'Bloqueo Cliente', inputType: 'text' }, { field: 'usubloqueacliente', title: 'Usu Bloquea Cliente', inputType: 'text' },
    { field: 'fecbloqueocliente', title: 'Fec. Bloqueo Cliente', inputType: 'datetime' }, { field: 'obserbloqueocliente', title: 'Obser. Bloqueo Cliente', inputType: 'text' },
    { field: 'bloqueoproveedor', title: 'Bloqueo Proveedor', inputType: 'checkbox' }, { field: 'usubloqueaproveedor', title: 'Usu. Bloquea Proveedor', inputType: 'text' },
    { field: 'fecbloqueoproveedor', title: 'Fec. Bloqueo Proveedor', inputType: 'datetime' }, { field: 'obserbloqueoproveedor', title: 'Obser. Bloqueo Proveedor', inputType: 'text' },
    { field: 'obserproveedor', title: 'Obser. Proveedor', inputType: 'text' }, { field: 'asumedetraccion', title: 'Asume Detracción', inputType: 'checkbox' },
    { field: 'usuariocrea', title: 'Usuario Crea', inputType: 'text' }, { field: 'fechacrea', title: 'Fecha Crea', inputType: 'datetime' },
    { field: 'usuariomodifica', title: 'Usuario Modifica', inputType: 'text' }, { field: 'fechamodifica', title: 'Fecha Modifica', inputType: 'datetime' }
  ]

  metadataTableLimiteCredito: newmetadate[] = [
    { field: 'enlI_TiposDescripcion', title: 'Tipo', inputType: 'autocomplete', dropdown: this.ListaTipoLimiteCredito, required: true },
    { field: 'tipO_MND', title: 'Moneda', inputType: 'autocomplete', dropdown: this.ListaTodosMoneda, required: true },
    { field: 'enlI_Monto', title: 'Monto', inputType: 'int', required: true },
    { field: 'enlI_FecInicio', title: 'Fecha Inicio', inputType: 'date' },
    { field: 'enlI_FecVencimiento', title: 'FechaVencimiento', inputType: 'date' },
    { field: 'enlI_FormaPagoDescripcion', title: 'Forma Pago', inputType: 'autocomplete', dropdown: this.formapago },
    { field: 'enlI_Notas', title: 'Notas', inputType: 'text' },
  ]

  metadataTableHistorial: newmetadate[] = [
    { field: 'enlI_Codigo', title: 'Código', inputType: 'text' }, { field: 'tipO_MND', title: 'Moneda', inputType: 'text' },
    { field: 'enlI_Monto', title: 'Monto', inputType: 'decimal' }, { field: 'enlI_Fecha', title: 'Fecha Convenio', inputType: 'date' },
    { field: 'enlI_DiasDuracion', title: 'Dias', inputType: 'int' }
  ]

  filtrarServicio() {
    //   const regimen = this.groupPS.value.regimen
    //   const lineanegocio = this.groupPS.value.lineanegocio
    //   const via = this.groupPS.value.via
    //   this.listaServicios = this.servicios.slice().filter(r => r.regimen === regimen)
    //   if (lineanegocio != null) {
    //     this.listaServicios = this.listaServicios.slice().filter(r => r.lineaNegocio === lineanegocio)
    //   }
    //   if (via != null) {
    //     this.listaServicios = this.listaServicios.slice().filter(r => r.via === via)
    //   }
    // }


    this.listaServicios = this.servicios.slice();
  }



  listVia: any[] = []
  servicios: any[] = []
  listaServicios: any[] = []
  ListarTipoRequest: any[] = []
  groupTC: FormGroup
  ngOnInitFormGroup() {

    this.groupPoppupDG = new FormGroup({
      codigo: new FormControl(null, null), activo: new FormControl(null, null),
      tipopersona: new FormControl("J", null), tipodocumento: new FormControl(null, null),
      numerodocumento: new FormControl(null, null), razonsocial: new FormControl(null, null),
      razoncomercial: new FormControl(null, null), nomgerente: new FormControl(null, null),
      fechanacimientog: new FormControl(null, null), fechaAniversariog: new FormControl(null, null),
      apellidopaterno: new FormControl(null, null), apellidomaterno: new FormControl(null, null),
      nombres: new FormControl(null, null), sexo: new FormControl(null, null),
      area: new FormControl(null, null), cargo: new FormControl(null, null),
      fechanacimiento: new FormControl(null, null), fechaingreso: new FormControl(null, null),
      correo: new FormControl(null, this.multiEmailTrimmedValidator), contactonombre: new FormControl(null, null),
      contactoapellidos: new FormControl(null, null), correoexport: new FormControl(null, this.multiEmailTrimmedValidator),
      direccion: new FormControl(null, null), pais: new FormControl(null, null),
      departamento: new FormControl(null, null), provincia: new FormControl(null, null),
      distrito: new FormControl(null, null), atributosadic: new FormControl(null, null),
      diascreditos: new FormControl(null, null), cobrofh: new FormControl(null, null),
      observaciones: new FormControl(null, null), nodomiciliado: new FormControl(null, null),
      prospecto: new FormControl(null, null), cobrodf: new FormControl(null, null),
    })

    this.groupPoppupD = new FormGroup({
      correofinanzas: new FormControl(null, Validators.email),
      ctaintersoles: new FormControl(null, null),
      ctainterdolares: new FormControl(null, null),
      ctadetracciones: new FormControl(null, null),
      asumedetraccion: new FormControl(null, null)
    })
    this.groupPoppupB = new FormGroup({
      bloqueado: new FormControl(null, null),
      usuariobloqueo: new FormControl(null, null),
      comentariobloqueo: new FormControl(null, null),
      fechabloqueoo: new FormControl(null, null)
    })
    this.groupPS = new FormGroup({
      servicios: new FormControl(null, null),
      regimen: new FormControl(null),
      lineanegocio: new FormControl(null, null),
      via: new FormControl(null, null)
    })
    this.groupOD = new FormGroup({
      departamento: new FormControl(null, null),
      provincia: new FormControl(null, null),
      distrito: new FormControl(null, null)
    })
    this.groupTC = new FormGroup({
      tipocarga: new FormControl(null, null)
    })
  }

  async ngOnInit() {
    this.fechaActual = new Date();
    this.ngOnInitFormGroup()
    this.group = new FormGroup({
      numdocumento: new FormControl(null, null), razonsocial: new FormControl(null, null)
    })

    //  await this.listarTipos('PAI', this.listPais)
    //  await this.listarTipos('TDI', this.ListaTodosTipoDoc)

    //   // setTimeout(() => {
    // await this.ngOnInitFormGroup()

    //   // }, 2000
    //   // );

    this.loadParameters()
  }


  //    async ngOnInit(): Promise<void> {
  //       this.group = new FormGroup({
  //       numdocumento: new FormControl(null, null), razonsocial: new FormControl(null, null)
  //      })
  //    await Promise.all([
  //     this.listarTipos('PAI', this.listPais),
  //      this.listarTipos('TDI', this.ListaTodosTipoDoc),
  //    ]);

  // await this.ngOnInitFormGroup(),
  //    await this.loadParameters()
  // }


  listarTipos(tipo: string, tabla: any[]) {
    const request = <ListarTipoRequest>{}
    request.TIPO_CodTabla = tipo

    this.soporte.listarTipo(request).subscribe(response => {

      if (response.datos.status == 200) {

        response.datos.result.map(r => {
          const item = {
            codigo: r.tipO_CodTipo,
            nombre: r.tipO_Desc1
          }
          tabla.push(item)
        })
      }

    })
  }

  async loadParameters() {
    let loading = this.util.showLoadingScreen({ message: "Cargando" })
    let parametros: any = await this.util.obtenerDatos([{ tipo: 'TODOS' }])
    this.tipo = [{ name: 'Jurídica', key: 'J' }, { name: 'Natural', key: 'N' }];
    this.sexo = [{ name: 'Femenino', key: 'F' }, { name: 'Masculino', key: 'M' }];

    let tipo: SelectItem[] = [{ label: 'CUENTA CORRIENTE', value: 'C' }, { label: 'CUENTA DE AHORROS', value: 'A' }, { label: 'CUENTA MAESTRA', value: 'M' }];
    this.tipocuenta.push(...tipo)
    let formap: SelectItem[] = [{ label: 'CHEQUE DIFERIDO', value: 'C' }, { label: 'CONTRA DOCUMENTO', value: 'D' }];
    this.formapago.push(...formap)

    // this.ListaTodosTipoDoc = parametros.slice().filter(r => r.tipo === 'TIPODOC')

    parametros.map(r => {

      switch (r.tipo) {
        case "BANCO":
          const a: SelectItem = { label: r.nombre, value: r.codigo }
          this.ListaTodosBanco.push(a)
          break;
        case "MONEDA":
          const b: SelectItem = { label: r.nombre, value: r.codigo }
          this.ListaTodosMoneda.push(b)
          break;
        case "SERVICIO":
          this.servicios.push(r)
          break;
        case "TCARGA":
          const c = { label: r.nombre, value: r.codigo }
          this.listaTodosCarga.push(c)
          break;
        case "PAI":
          const d = { label: r.nombre, value: r.codigo }
          this.listPais.push(d)
          break;
        case "TIPODOC":
          const e = { label: r.nombre, value: r.codigo }
          this.ListaTodosTipoDoc.push(e)
          break;
        default:
          break;
      }
    })

    this.listReg = this.util.getParameterByType("RGM")
    this.listVia = this.util.getParameterByType("VIA")
    this.lineaNegocio = this.util.getParameterByType("LNG")
    // this.ngOnInitFormGroup()

    if (this.groupPoppupDG) {
      const currentValue = this.groupPoppupDG.get('tipodocumento')?.value;
      this.groupPoppupDG.get('tipodocumento')?.setValue(currentValue, { emitEvent: true });
      this.groupPoppupDG.get('tipodocumento')?.updateValueAndValidity();
      this.cdr.detectChanges();
    }

    loading.close()
  }

  guardarServicio() {
    if (this.groupPS.valid) {
      const value = this.groupPS.value
      var regimen = value.regimen
      regimen = this.groupPS.value.regimen
    }
  }

  // search() {
  //   const values = this.group.value
  //   const Request: ListarEntidadesRequest = <ListarEntidadesRequest>{}
  //   Request.pintENTC_Codigo = null
  //   Request.pvchENTC_NomCompleto = values['razonsocial']  
  //   Request.pvchTIPE_Codigo = 2
  //   Request.pvchENTC_DocIden = values['numdocumento']
  //   this.dataTable = []
  //   this.mantcomercial.ListarEntidades(Request).subscribe(response => {


  //     if (response.datos.status === 200) { this.dataTable = response.datos.result } else {
  //       this.dataTable = []
  //       this.util.ShowMessage({ titulo: "ERROR", mensaje: "No se encontraron datos", icono: "pi pi-exclamation-triangle", tipo: "warning" });
  //     }
  //   })
  // }
  search() {
    const values = this.group.value;

    const loading = this.util.showLoadingScreen({ message: "Buscando..." });

    const Request: ListarEntidadesRequest = <ListarEntidadesRequest>{};
    Request.pintENTC_Codigo = null;
    Request.pvchENTC_NomCompleto = values['razonsocial'];
    Request.pvchTIPE_Codigo = 2;
    Request.pvchENTC_DocIden = values['numdocumento'];

    this.dataTable = [];

    this.mantcomercial.ListarEntidades(Request).subscribe({
      next: (response) => {
        if (response.datos.status === 200 && response.datos.result?.length > 0) {
          this.dataTable = response.datos.result;
        } else {
          this.dataTable = [];
          this.util.ShowMessage({
            titulo: "Advertencia", mensaje: "No se encontraron datos", icono: "pi pi-exclamation-triangle", tipo: "warning"
          });
        }
        loading.close();
      },
      error: (err) => {
        console.error('Error en la búsqueda:', err);
        this.util.ShowMessage({
          titulo: "Error", mensaje: "No se encontraron los datos buscados.", icono: "pi pi-times-circle", tipo: "error"
        });
        loading.close();
      }
    });
  }

  //   async validarDocumento() {
  //     const values = this.groupPoppupDG.value
  //     const Request: ValidarDocIdentidadRequest = <ValidarDocIdentidadRequest>{}
  //     Request.pintENTC_Codigo = 0
  //     Request.pchrTIPO_TabTDI = 'TDI'
  //     Request.pchrTIPO_CodTDI = values['tipodocumento']
  //     Request.pvchENTC_DocIden = values['numerodocumento']
  //     this.mantcomercial.ValidarEntidadSunat(Request).subscribe(response => {
  //       if (response.datos.status === 200) {
  //         this.editProveedor('', response.datos.result[0])
  //         this.messageService.clear();
  //         this.messageService.add({ key: 'toast1', severity: 'success', summary: 'OK', detail: 'Se cargó la información correctamente.' });
  //       }
  //     }, (errorServicio => {
  //       const requestSunat: sunatRequest = <sunatRequest>{}
  //       requestSunat.razonsocial = values["razonSocial"]
  //       requestSunat.ruc = values["numerodocumento"]
  //       this.proformaService.listarSunat(requestSunat).subscribe({
  //       next: async (response) => {
  //       //  if (response.datos.result.length > 0) {
  //           const rawNombre = response.datos.result[0].nombre_o_razon_social || '';
  //           const nombre_o_razon_social = rawNombre.replace(/\\/g, '');
  //           this.groupPoppupDG.get('razonsocial').setValue(nombre_o_razon_social)
  //           this.groupPoppupDG.get('direccion').setValue(response.datos.result[0].direccion_completa)
  //           // asignar pais departamento distrito y provincia
  //           const ubigeo = response.datos.result[0].ubigeo;
  //           const ubigeoFormateado = ubigeo?.length === 6 ? ubigeo.slice(0, 2) + '.' + ubigeo.slice(2, 4) + '.' + ubigeo.slice(4, 6) : ubigeo;
  //           const tipo_codpais = "179"; // peru por default
  //           const pai = this.listPais.find(r => r.value.toUpperCase() === tipo_codpais.toUpperCase())?.value
  //           this.groupPoppupDG.get('pais')?.setValue(pai);
  //           const partes = ubigeoFormateado?.split(".");
  //           const departamento = partes[0];
  //           const provincia = `${partes[0]}.${partes[1]}`;
  //           const distrito = ubigeoFormateado;
  //          // this.onPaisSeleccionado(pai, 'INI')
  //        //    this.onPaisSeleccionado(null, pai)
  //          await   this.onPaisSeleccionadoAsync(null,pai)
  //           this.groupPoppupDG.get('departamento')?.setValue(departamento);

  //           //this.onDepartamentoSeleccionado(departamento, 'INI')
  //            this.onDepartamentoSeleccionado(null,departamento)
  //           this.groupPoppupDG.get('provincia')?.setValue(provincia);
  //           //this.onprovinciaSeleccionada(provincia, 'INI')
  //            this.onprovinciaSeleccionada(null,provincia)
  //           this.groupPoppupDG.get('distrito')?.setValue(distrito);
  //           this.messageService.clear();
  //           this.messageService.add({ key: 'toast1', severity: 'success', summary: 'OK', detail: 'El documento de identidad se encuentra registrado en SUNAT.' });


  //  },
  //           error: (err) => {
  //             this.messageService.clear();
  //             this.messageService.add({
  //               key: 'toast2',
  //               severity: 'error',
  //               summary: 'Error',
  //               detail: 'El documento de identidad no se encuentra registrado en SUNAT, por favor verifique.'
  //             });
  //           }
  //     }))
  //   }


  //  validarDocumento() {
  //   const values = this.groupPoppupDG.value
  //   const Request: ValidarDocIdentidadRequest = <ValidarDocIdentidadRequest>{}
  //   Request.pintENTC_Codigo = 0
  //   Request.pchrTIPO_TabTDI = 'TDI'
  //   Request.pchrTIPO_CodTDI = values['tipodocumento']
  //   Request.pvchENTC_DocIden = values['numerodocumento']

  //   this.mantcomercial.ValidarEntidadSunat(Request).subscribe(response => {
  //     if (response.datos.status === 200) {
  //       this.editProveedor('', response.datos.result[0])
  //       this.messageService.clear();
  //       this.messageService.add({
  //         key: 'toast2',
  //         severity: 'info',
  //         summary: 'CLIENTE YA REGISTRADO',
  //         detail: 'El documento de identidad ya se encuentra registrado.',
  //         life: 10000
  //       });
  //     }
  //   }, (errorServicio => {
  //     if (values['tipodocumento'] === '001') {
  //       const requestSunat: sunatRequest = <sunatRequest>{}
  //       requestSunat.razonsocial = values["razonSocial"]
  //       requestSunat.ruc = values["numerodocumento"]

  //       this.proformaService.listarSunat(requestSunat).subscribe(
  //          async (response) => {
  //           // Validar si la respuesta y los datos son válidos antes de continuar
  //           if (!response?.datos?.result?.length) {
  //             this.messageService.clear();
  //             this.messageService.add({
  //               key: 'toast2',
  //               severity: 'error',
  //               summary: 'Error',
  //               detail: 'El documento de identidad no se encuentra registrado en SUNAT, por favor verifique.'
  //             });
  //             return;
  //           }

  //           const sunatData = response.datos.result[0];

  //           // Usar optional chaining y nullish coalescing para un acceso seguro a las propiedades
  //           const nombre_o_razon_social = sunatData.nombre_o_razon_social?.replace(/\\/g, '') || '';
  //           const direccion_completa = sunatData.direccion_completa || '';
  //           const estado_sunat = sunatData.estado_del_controbuyente || '';

  //          values['razonsocial']?.setValue(nombre_o_razon_social);
  //           values['razoncomercial']?.setValue(nombre_o_razon_social);
  //           values['direccion']?.setValue(direccion_completa);
  //           values['estadoSunat']?.setValue(estado_sunat);

  //           // Lógica para el ubigeo
  //           const ubigeo = sunatData.ubigeo;
  //           const ubigeoFormateado = ubigeo?.length === 6 ? `${ubigeo.slice(0, 2)}.${ubigeo.slice(2, 4)}.${ubigeo.slice(4, 6)}` : ubigeo;
  //           const tipo_codpais = "179"; // Perú por defecto

  //           // Asegúrate de que listPais esté poblada
  //           const pais = this.listPais.find(r => r.codigo?.toUpperCase() === tipo_codpais.toUpperCase())?.codigo;

  //           if (pais) {
  //             values['pais']?.setValue(pais);

  //             // Ahora llamamos a las funciones de ubigeo de forma secuencial y asíncrona
  //             const partes = ubigeoFormateado?.split(".");
  //             if (partes?.length === 3) {
  //               const departamento = partes[0];
  //               const provincia = `${partes[0]}.${partes[1]}`;
  //               const distrito = ubigeoFormateado;

  //               // Esperar a que cada llamada asíncrona complete antes de continuar
  //               await this.onPaisSeleccionadoAsync(null ,pais);
  //                 this.groupPoppupDG.patchValue({
  //                 departamento: departamento
  //                 });


  //            //   await this.onDepartamentoSeleccionadoAsync(departamento, 'fiscal');
  //           //    this.groupPoppupDG.get('provincia')?.setValue(provincia);

  //            //   await this.onprovinciaSeleccionadaAsync(provincia, 'fiscal');
  //             //  this.groupPoppupDG.get('distrito')?.setValue(distrito);
  //             }
  //           }

  //           // this.informacionSunat("disable")
  //           this.messageService.clear();
  //           this.messageService.add({
  //             key: 'toast1',
  //             severity: 'success',
  //             summary: 'OK',
  //             detail: 'El documento de identidad se encuentra registrado en SUNAT.'
  //           });
  //         }),
  //         error: (err) => {
  //           this.messageService.clear();
  //           this.messageService.add({
  //             key: 'toast2',
  //             severity: 'error',
  //             summary: 'Error',
  //             detail: 'El documento de identidad no se encuentra registrado en SUNAT, por favor verifique.'
  //           });
  //         }

  //     } else if (values['tipodocumento'] === '002') {
  //       this.proformaService.consultaDNI({ dni: values['numerodocumento'], token: null }).subscribe({
  //         next: (response) => {
  //           // Validar si la respuesta y los datos son válidos antes de continuar
  //           if (response.datos.status === 200) {
  //             this.messageService.clear();
  //             this.messageService.add({
  //               key: 'toast1',
  //               severity: 'success',
  //               summary: 'RENIEC',
  //               detail: 'El documento de identidad se encuentra registrado en RENIEC.'
  //             });
  //             // Llenar los campos de apellido y nombre
  //             const dniData = response.datos.result[0];

  //             // Separar nombres y apellidos de dniData.nombre_completo
  //             const nombresCompletos = dniData.nombre_completo ? dniData.nombre_completo.split(' ') : [];
  //             const apellidoPaterno = nombresCompletos.length > 0 ? nombresCompletos[0] : '';
  //             const apellidoMaterno = nombresCompletos.length > 1 ? nombresCompletos[1] : '';
  //             const nombres = nombresCompletos.length > 2 ? nombresCompletos.slice(2).join(' ') : '';
  //            values['apellidopaterno']?.setValue(apellidoPaterno);
  //             values['apellidomaterno']?.setValue(apellidoMaterno);
  //             values['nombres']?.setValue(nombres);
  //             // this.groupPoppupDG.get('sexo')?.setValue(dniData.sexo || '');
  //             // this.groupPoppupDG.get('fechanacimiento')?.setValue(dniData.fecha_nacimiento ? new Date(dniData.fecha_nacimiento) : null);
  //           }
  //         },
  //         error: (err) => {
  //           if (err.error.datos.status === 404) {
  //             this.messageService.clear();
  //             this.messageService.add({
  //               key: 'toast2',
  //               severity: 'error',
  //               summary: 'Error',
  //               detail: 'El documento de identidad no se encuentra registrado en RENIEC, por favor verifique.'
  //             });
  //           }
  //         }
  //       });
  //     }
  //   }))

  // }


  getDatosByRuc() {
    const values = this.groupPoppupDG.value;
    const Request: ValidarDocIdentidadRequest = {
      pintENTC_Codigo: 0,
      pchrTIPO_TabTDI: 'TDI',
      pchrTIPO_CodTDI: values['tipodocumento'],
      pvchENTC_DocIden: values['numerodocumento']
    };

    this.mantcomercial.ValidarEntidadSunat(Request).subscribe({
      next: (response) => {
        if (response.datos.status === 200) {
          this.editProveedor('', response.datos.result[0]);
          this.messageService.clear();
          this.messageService.add({
            key: 'toast2',
            severity: 'info',
            summary: 'CLIENTE YA REGISTRADO',
            detail: 'El documento de identidad ya se encuentra registrado.',
            life: 10000
          });
        }
      },

      error: () => {
        if (values['tipodocumento'] === '001') {
          const requestSunat: sunatRequest = {
            razonsocial: values['razonSocial'],
            ruc: values['numerodocumento']
          };

          this.proformaService.listarSunat(requestSunat).subscribe({
            next: async (response) => {
              if (!response?.datos?.result?.length) {
                this.messageService.add({
                  key: 'toast2', severity: 'error', summary: 'Error', detail: 'No registrado en SUNAT'
                });
                return;
              }

              const sunatData = response.datos.result[0];

              if (values['tipopersona'] === 'N') {
                const nombresCompletos = sunatData.nombre_o_razon_social ? sunatData.nombre_o_razon_social.split(' ') : [];
                const apellidoPaterno = nombresCompletos.length > 0 ? nombresCompletos[0] : '';
                const apellidoMaterno = nombresCompletos.length > 1 ? nombresCompletos[1] : '';
                const nombres = nombresCompletos.length > 2 ? nombresCompletos.slice(2).join(' ') : '';
                this.groupPoppupDG.get('apellidopaterno')?.setValue(apellidoPaterno);
                this.groupPoppupDG.get('apellidomaterno')?.setValue(apellidoMaterno);
                this.groupPoppupDG.get('nombres')?.setValue(nombres);
              }

              this.groupPoppupDG.patchValue({
                razonsocial: sunatData.nombre_o_razon_social ?? '',
                razoncomercial: sunatData.nombre_o_razon_social ?? '',
                direccion: sunatData.direccion_completa ?? '',
                estadoSunat: sunatData.estado_del_controbuyente ?? ''
              });

              const ubigeo = sunatData.ubigeo;
              if (ubigeo?.length === 6) {
                const departamento = ubigeo.substring(0, 2);
                const ubigeoFormateado = ubigeo?.length === 6 ? `${ubigeo?.slice(0, 2)}.${ubigeo?.slice(2, 4)}.${ubigeo?.slice(4, 6)}` : ubigeo;
                var pais = 179;

                const partes = ubigeoFormateado?.split(".");
                if (partes?.length === 3) {

                  const partes = ubigeoFormateado?.split(".");
                  const departamento = partes?.[0] ?? null;
                  const provincia = partes?.[0] && partes?.[1] ? `${partes[0]}.${partes[1]}` : null;
                  const distrito = ubigeoFormateado ?? null;

                  this.groupPoppupDG.patchValue({
                    pais: pais ?? ''
                  });

                  //    this.groupPoppupDG.get('pais')?.setValue(pais);
                  await this.onPaisSeleccionado(pais, 'INI');
                  // this.groupPoppupDG.get('departamento')?.setValue(departamento);
                  this.groupPoppupDG.patchValue({
                    departamento: departamento ?? ''
                  });
                  await this.onDepartamentoSeleccionado(departamento, 'INI');
                  // this.groupPoppupDG.get('provincia')?.setValue(provincia);
                  this.groupPoppupDG.patchValue({
                    provincia: provincia ?? ''
                  });
                  await this.onprovinciaSeleccionada(provincia, 'INI');
                  this.groupPoppupDG.patchValue({
                    distrito: distrito ?? ''
                  });

                  //this.groupPoppupDG.get('distrito')?.setValue(distrito);
                  //             }

                }
              }

              this.messageService.add({
                key: 'toast1',
                severity: 'success',
                summary: 'SUNAT',
                detail: 'Documento encontrado en SUNAT'
              });
            },

            error: () => {
              this.messageService.add({
                key: 'toast2', severity: 'error', summary: 'Error', detail: 'SUNAT no disponible'
              });
            }
          });
        }
      }
    });
  }

  validarDocumento() {
    const values = this.groupPoppupDG.value
    const documento = this.groupPoppupDG.get('tipodocumento')?.value;
    if (documento === '001' || documento === '002') {
      switch (documento) {
        case '001':
          if (documento != '' && documento != null) this.getDatosByRuc();
          break;
        case '002':
          if (documento != '' && documento != null) this.getDatosByDni(values['numerodocumento']);
          break;
        default:
          break;
      }
    }
  }

  getDatosByDni(documentos: string) {
    const values = this.groupPoppupDG.value
    const Request: ValidarDocIdentidadRequest = <ValidarDocIdentidadRequest>{}
    Request.pintENTC_Codigo = 0;
    Request.pchrTIPO_TabTDI = 'TDI';
    Request.pchrTIPO_CodTDI = this.groupPoppupDG.get('tipodocumento')?.value;
    Request.pvchENTC_DocIden = values['numerodocumento'];
    this.mantcomercial.ValidarEntidadSunat(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.editProveedor('', response.datos.result[0])
        this.messageService.clear();
        this.messageService.add({ key: 'toast1', severity: 'success', summary: 'OK', detail: 'Se cargó la información correctamente.' });
      }
    }, (errorServicio => {
      this.proformaService.consultaDNI({ dni: documentos, token: null }).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            this.messageService.clear();
            this.messageService.add({
              key: 'toast1', severity: 'success', summary: 'RENIEC',
              detail: 'El documento de identidad se encuentra registrado en RENIEC.'
            });
            const dniData = response.datos.result[0];
            const nombresCompletos = dniData.nombre_completo ? dniData.nombre_completo.split(' ') : [];
            const apellidoPaterno = nombresCompletos.length > 0 ? nombresCompletos[0] : '';
            const apellidoMaterno = nombresCompletos.length > 1 ? nombresCompletos[1] : '';
            const nombres = nombresCompletos.length > 2 ? nombresCompletos.slice(2).join(' ') : '';
            this.groupPoppupDG.get('apellidopaterno')?.setValue(apellidoPaterno);
            this.groupPoppupDG.get('apellidomaterno')?.setValue(apellidoMaterno);
            this.groupPoppupDG.get('nombres')?.setValue(nombres);
          }
        },
        error: (err) => {
          if (err.error.datos.status === 404) {
            this.messageService.clear();
            this.messageService.add({
              key: 'toast2', severity: 'error', summary: 'Error',
              detail: 'El documento de identidad no se encuentra registrado en RENIEC, por favor verifique.'
            });
          }
        }
      });
    }))
  }

  onChangeTipoDocumento(tipo: string, valor: any) {
    let tipo_doc;
    if (tipo === 'EVE') {
      tipo_doc = valor?.value ?? null;
      this.verNumDoc(tipo_doc);
    } else if (tipo === 'INI') {
      tipo_doc = valor;
    }
    if (tipo_doc === '002') {
      this.natural = true;
      this.juridica = false;
    } else if (tipo_doc === '001') {
      this.juridica = true;
      this.natural = false;
    }
  }

  verInputs(event) {
    const values = this.groupPoppupDG.value
    if (event === 'J' || values.tipopersona === 'J') {
      this.juridica = true, this.natural = false
    } else if (event === 'N' || values.tipopersona === 'N') {
      this.juridica = false, this.natural = true
    }
  }
  codpai: number
  onPaisSeleccionado(event: any, tipo: string) {
    let valor;
    if (tipo == 'EVE') {
      valor = event.value;
    } else if (tipo == 'INI') {
      valor = event;
    }
    if (valor != null) {
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
      request.pvchUBIG_Codigo = null
      request.pchrTIPO_CodPais = valor;
      request.pchrTIPO_TabPais = 'PAI'
      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const departamento = response.datos.result.filter(item => item.ubiG_CodPadre === null);
        this.listDepartamento = departamento;
      },
        err => {
          this.listDepartamento = [];
          this.listProvincia = [];
          this.listDistrito = [];
        });
    } else {
      this.listDepartamento = [];
      this.listProvincia = [];
      this.listDistrito = [];
    }
  }

  onDepartamentoSeleccionado(event: any, tipo: string) {
    let valor;
    if (tipo == 'EVE') {
      valor = event.value;
    } else if (tipo == 'INI') {
      valor = event;
    }
    if (valor != null) {
      const departamentoSeleccionado = valor;
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
      request.pvchUBIG_Codigo = null
      request.pchrTIPO_CodPais = this.groupPoppupDG.get('pais').value;
      request.pchrTIPO_TabPais = 'PAI'
      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const provincias = response.datos.result.filter(item => item.ubiG_CodPadre === departamentoSeleccionado);
        this.listProvincia = provincias;
      }, err => { this.listProvincia = []; });
    } else {
      this.listProvincia = [];
    }
  }
  onprovinciaSeleccionada(event: any, tipo: string) {
    let valor;
    if (tipo == 'EVE') {
      valor = event.value;
    } else if (tipo == 'INI') {
      valor = event;
    }
    if (valor != null) {
      const provinciaseleccionada = valor;
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
      request.pvchUBIG_Codigo = null
      request.pchrTIPO_CodPais = this.groupPoppupDG.get('pais').value;
      request.pchrTIPO_TabPais = 'PAI'
      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const distritos = response.datos.result.filter(item => item.ubiG_CodPadre === provinciaseleccionada);
        this.listDistrito = distritos;
      },
        err => {
          this.listDistrito = [];
        });
    } else {
      this.listDistrito = [];
    }
  }

  //  Esto es para OTROS DATOS

  async onDepartamentoOSeleccionado(event: any, codigo: any) {
    let departamentoSeleccionado: any
    if (event === null && codigo != null) {
      departamentoSeleccionado = codigo;
    } else if (event != null && codigo === null) {
      departamentoSeleccionado = event.value.ubiG_Codigo;
    }
    const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
    request.pvchUBIG_Codigo = null
    request.pchrTIPO_CodPais = 179
    request.pchrTIPO_TabPais = 'PAI'
    this.listProvinciaO = []
    const depa = departamentoSeleccionado;
    this.mantcomercial.ListarUbigeos(request).subscribe(response => {
      const provincias = response.datos.result.filter(item => item.ubiG_CodPadre === depa);
      this.listProvinciaO = provincias;
    });
  }

  onProvinciaOSeleccionado(event: any, codigo: any) {
    let provinciaSeleccionada: any;
    if (event === null && codigo != null) {
      provinciaSeleccionada = codigo;
    } else if (event != null && codigo === null) {
      provinciaSeleccionada = event.value.ubiG_Codigo;
    }
    const request: ListarUbigeosRequest = <ListarUbigeosRequest>{};
    request.pvchUBIG_Codigo = null;
    request.pchrTIPO_CodPais = 179;
    request.pchrTIPO_TabPais = 'PAI';

    this.listDistritoO = []; // Limpiamos antes de asignar
    const prov = provinciaSeleccionada;
    this.mantcomercial.ListarUbigeos(request).subscribe(response => {
      const distritos = response.datos.result.filter(item => item.ubiG_CodPadre === prov);
      this.listDistritoO = distritos;
    });
  }


  nuevo() {
    this.prueba = false
    this.visible = true
    this.visiblebtn = true
    this.entcCod = 0
    this.groupPoppupDG.reset()
    this.groupPoppupD.reset()
    this.groupPoppupB.reset()
    this.groupPoppupDG.get('tipopersona').setValue("J")
    this.dataTableCuentasBancarias = []
    this.dataTableServicios = []
    this.dataTableLimiteCredito = []
    this.dataTableAuditoria = []
    this.dataTableDireccion = []
    this.dataTableArchivos = []
    this.uploadedFiles = []
    this.groupPoppupDG.get('activo').setValue(true)
    // this.groupPoppupDG.get('vip').setValue(false);
    this.groupPoppupDG.get('diascreditos').setValue(0);
    this.groupPoppupDG.get('nodomiciliado').setValue(false);
    //  this.groupPoppupDG.get('prospecto').setValue(false);
    // const td = this.ListaTodosTipoDoc.find(r => r.codigo.toUpperCase() === '001')?.codigo
    // this.groupPoppupDG.get('tipodocumento').setValue(td)

    // const RequestLC: ListarLimiteCreditoRequest = <ListarLimiteCreditoRequest>{}
    // RequestLC.pintENTC_Codigo = 0
    // RequestLC.psinTIPE_Codigo = 2
    // this.dataTableLimiteCredito = []
    // this.mantcomercial.ListarLimiteCredito(RequestLC).subscribe(response => {
    //   if (response.datos.status === 200) { this.dataTableLimiteCredito = response.datos.result }
    // })
    this.cdr.detectChanges();
  }

  listadoEdit(entcCodigo) {
    const RequestCB: ListarCuentasBancariasRequest = <ListarCuentasBancariasRequest>{}
    RequestCB.pintENTC_Codigo = entcCodigo
    this.dataTableCuentasBancarias = []
    this.mantcomercial.ListarCuentasBancarias(RequestCB).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableCuentasBancarias = response.datos.result }
    })
    const RequestLC: ListarLimiteCreditoRequest = <ListarLimiteCreditoRequest>{}
    RequestLC.pintENTC_Codigo = entcCodigo
    RequestLC.psinTIPE_Codigo = 2
    this.dataTableLimiteCredito = []
    this.mantcomercial.ListarLimiteCredito(RequestLC).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableLimiteCredito = response.datos.result.map(r => {
          return {
            ...r,
            enlI_FecInicio: r.enlI_FecInicio != null ? new Date(r.enlI_FecInicio) : null,
            enlI_FecVencimiento: r.enlI_FecVencimiento != null ? new Date(r.enlI_FecVencimiento) : null
          }
        })
        this.ListaTipoLimiteCredito = this.dataTableLimiteCredito.map(r => ({ label: r.enlI_TiposDescripcion, value: r.enlI_Tipos }))
        this.metadataTableLimiteCredito[0].dropdown = this.ListaTipoLimiteCredito;
      }
    })
    const RequestAU: ListarAuditoriaRequest = <ListarAuditoriaRequest>{}
    RequestAU.pintENTC_Codigo = entcCodigo
    this.dataTableAuditoria = []
    this.mantcomercial.ListarAuditoria(RequestAU).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableAuditoria = response.datos.result }
    })
    const RequestAR: ListarArchivoEntidadRequest = <ListarArchivoEntidadRequest>{}
    RequestAR.ENAR_Codigo = 0
    RequestAR.ENTC_Codigo = entcCodigo
    this.uploadedFiles = []
    this.mantcomercial.ListarArchivosEntidad(RequestAR).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableArchivos = response.datos.result
        this.uploadedFiles = this.dataTableArchivos.map(r => ({
          codigo: r.enaR_Codigo, tipotran: 'U', image: null, usuario: r.audI_UsrCrea, fecha: r.audI_FecCrea, nombre: r.enaR_NombreArchivo, url: r.enaR_Archivo
        }))
      }
    })
    const RequestDO: ConsultarDireccionEntidadRequest = <ConsultarDireccionEntidadRequest>{}
    RequestDO.pintENTC_Codigo = entcCodigo
    this.dataTableDireccion = []
    this.mantcomercial.ConsultarDireccionEntidad(RequestDO).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableDireccion = response.datos.result
        this.dataTableDireccion.forEach(row => {
          if (row && row.dirE_Codigo === 1) {
            this.groupPoppupDG.get('direccion')?.setValue(row.dirE_Direccion);
            const pai = this.listPais?.find(r => r.value.toUpperCase() === row.tipO_CodPais.toUpperCase())?.value
            this.groupPoppupDG.get('pais')?.setValue(pai);
            const partes = row.ubiG_Codigo?.split(".");
            const departamento = partes?.[0] ?? null;
            const provincia = partes?.[0] && partes?.[1] ? `${partes[0]}.${partes[1]}` : null;
            const distrito = row.ubiG_Codigo ?? null;
            this.onPaisSeleccionado(pai, 'INI')
            this.groupPoppupDG.get('departamento')?.setValue(departamento);
            this.onDepartamentoSeleccionado(departamento, 'INI')
            this.groupPoppupDG.get('provincia')?.setValue(provincia);
            this.onprovinciaSeleccionada(provincia, 'INI')
            this.groupPoppupDG.get('distrito')?.setValue(distrito);
            // setTimeout(() => {
            //   const dp = this.listDepartamento?.find(r => r.ubiG_Codigo === departamento)?.ubiG_Codigo
            //   this.groupPoppupDG.get('departamento')?.setValue(dp);
            //   this.onDepartamentoSeleccionado(null, dp)
            //   setTimeout(() => {
            //     const pv = this.listProvincia?.find(r => r.ubiG_Codigo === provincia)?.ubiG_Codigo
            //     this.groupPoppupDG.get('provincia')?.setValue(pv);
            //     this.onprovinciaSeleccionada(null, pv)

            //     setTimeout(() => {
            //       const ds = this.listDistrito?.find(r => r.ubiG_Codigo === distrito)?.ubiG_Codigo
            //       this.groupPoppupDG.get('distrito')?.setValue(ds);
            //     }, 500);
            //   }, 700);
            // }, 900);
          }
        });
      }
    })
    const RequestTC: ListarTipoCargaRequest = <ListarTipoCargaRequest>{}
    RequestTC.ENTC_Codigo = entcCodigo
    this.dtT = []
    this.mantcomercial.ListarTipoCarga(RequestTC).subscribe(response => {
      if (response.datos.status === 200) { this.dtT = response.datos.result }
    })



    const RequestZT: ListarZonaTransporteRequest = <ListarZonaTransporteRequest>{}
    RequestZT.ENTC_Codigo = entcCodigo
    this.TableZonaTransporte = []
    this.mantcomercial.ListarZonaTransporte(RequestZT).subscribe(response => {
      if (response.datos.status === 200) { this.TableZonaTransporte = response.datos.result }
    })


    const RequestSP: ListarServiciosProveedoresRequest = <ListarServiciosProveedoresRequest>{}
    RequestSP.ENTC_Codigo = entcCodigo
    this.dtS = []
    this.mantcomercial.ListarServiciosProveedores(RequestSP).subscribe(response => {
      if (response.datos.status === 200) { this.dtS = response.datos.result }
    })
  }

  cargarInputBloqueo(event) {
    if (event === true) {
      this.groupPoppupB.get('usuariobloqueo').setValue(this.storage.get('usuario'))
      this.groupPoppupB.get('fechabloqueoo').setValue(new Date())
      this.groupPoppupB.get('usuariobloqueo').enable();
      this.groupPoppupB.get('fechabloqueoo').enable();
    } else {
      this.groupPoppupB.get('usuariobloqueo').setValue(null)
      this.groupPoppupB.get('fechabloqueoo').setValue(null)
      this.groupPoppupB.get('usuariobloqueo').disable();
      this.groupPoppupB.get('fechabloqueoo').disable();
    }
  }
  prueba: boolean = false
  correoface: string
  telfijo: string
  telmovil: string
  web: string
  row: ListarEntidades[] = []
  editProveedor(value, row: any) {
    this.prueba = true
    this.visiblebtn = false
    this.visible = true
    this.dataTableCuentasBancarias = []
    this.dataTableLimiteCredito = []
    this.dataTableAuditoria = []
    this.dataTableDireccion = []
    this.dataTableArchivos = []
    this.uploadedFiles = []
    this.dataTableServicios = []
    this.groupPoppupDG.reset()
    this.groupPoppupD.reset()
    this.groupPoppupB.reset()
    this.groupPoppupDG.get('tipopersona').setValue("J")
    if (row) {
      //DATOS GENERALES
      this.entcCod = row.entC_Codigo
      this.row = row
      this.listadoEdit(row.entC_Codigo)
      if (row.entC_Codigo) { this.groupPoppupDG.get('codigo').setValue(row.entC_Codigo) }
      if (row.entC_Activo) { this.groupPoppupDG.get('activo').setValue(row.entC_Activo) }
      if (row.entC_TipEnt) { this.groupPoppupDG.get('tipopersona').setValue(row.entC_TipEnt) }
      if (row.tipO_CodTDI) {
        const td = this.ListaTodosTipoDoc?.find(r => r.value.toUpperCase() === row?.tipO_CodTDI.toUpperCase())?.value
        if (td) {
          this.groupPoppupDG.get('tipodocumento').setValue(td)
          this.onChangeTipoDocumento('INI', td);
        }
      }
      if (row.entC_DocIden) { this.groupPoppupDG.get('numerodocumento').setValue(row.entC_DocIden) }
      if (row.entC_RazonSocial) { this.groupPoppupDG.get('razonsocial').setValue(row.entC_RazonSocial) }
      if (row.entC_NomComercial) { this.groupPoppupDG.get('razoncomercial').setValue(row.entC_NomComercial) }
      if (row.nombreGerente) { this.groupPoppupDG.get('nomgerente').setValue(row.nombreGerente) }
      if (row.fechaNacimiento) { this.groupPoppupDG.get('fechanacimientog').setValue(new Date(row.fechaNacimiento)) }
      if (row.fechaAniversario) { this.groupPoppupDG.get('fechaAniversariog').setValue(new Date(row.fechaAniversario)) }
      if (row.entC_ApePat) { this.groupPoppupDG.get('apellidopaterno').setValue(row.entC_ApePat) }
      if (row.entC_ApeMat) { this.groupPoppupDG.get('apellidomaterno').setValue(row.entC_ApeMat) }
      if (row.entC_Nombres) { this.groupPoppupDG.get('nombres').setValue(row.entC_Nombres) }
      if (row.entC_Sexo) { this.groupPoppupDG.get('sexo').setValue(row.entC_Sexo) }
      if (row.entC_Area) { this.groupPoppupDG.get('area').setValue(row.entC_Area) }
      if (row.entC_Cargo) { this.groupPoppupDG.get('cargo').setValue(row.entC_Cargo) }
      if (row.entC_FecNac) { this.groupPoppupDG.get('fechanacimiento').setValue(new Date(row.entC_FecNac)) }
      if (row.entC_FecIng) { this.groupPoppupDG.get('fechaingreso').setValue(new Date(row.entC_FecIng)) }
      if (row.entC_EMail) { this.groupPoppupDG.get('correo').setValue(row.entC_EMail) }
      if (row.entC_NombreContacto) { this.groupPoppupDG.get('contactonombre').setValue(row.entC_NombreContacto) }
      if (row.entC_ApellidoContacto) { this.groupPoppupDG.get('contactoapellidos').setValue(row.entC_ApellidoContacto) }
      if (row.entC_CorreoContactoExpo) { this.groupPoppupDG.get('correoexport').setValue(row.entC_CorreoContactoExpo) }
      // if (row.entC_FechaCredito) { this.groupPoppupDG.get('fechacredito').setValue(new Date(row.entC_FechaCredito)) }
      if (row.entC_DiasCredito) { this.groupPoppupDG.get('diascreditos').setValue(row.entC_DiasCredito ?? 0) }
      if (row.entC_Obser) { this.groupPoppupDG.get('observaciones').setValue(row.entC_Obser) }
      if (row.entC_Domiciliado) { this.groupPoppupDG.get('nodomiciliado').setValue(row.entC_Domiciliado) }
      //if (row.entC_VIP) { this.groupPoppupDG.get('vip').setValue(row.entC_VIP) }
      //if (row.entC_Prospecto) { this.groupPoppupDG.get('prospecto').setValue(row.entC_Prospecto) }
      //OTROS DATOS
      if (row.entC_EmailFinanzas) { this.groupPoppupD.get('correofinanzas').setValue(row.entC_EmailFinanzas) }
      if (row.entC_InterbancarioSol) { this.groupPoppupD.get('ctaintersoles').setValue(row.entC_InterbancarioSol) }
      if (row.entC_InterbancarioDol) { this.groupPoppupD.get('ctainterdolares').setValue(row.entC_InterbancarioDol) }
      if (row.entC_CuentaDetraccion) { this.groupPoppupD.get('ctadetracciones').setValue(row.entC_CuentaDetraccion) }
      if (row.entC_ProvAsumeDetraccion) { this.groupPoppupD.get('asumedetraccion').setValue(row.entC_ProvAsumeDetraccion) }
      //BLOQUEO
      if (row.entC_BloqueoFinanzasProveedor) { this.groupPoppupB.get('bloqueado').setValue(row.entC_BloqueoFinanzasProveedor) }
      if (row.entC_UsrBloqueoProveedor) { this.groupPoppupB.get('usuariobloqueo').setValue(row.entC_UsrBloqueoProveedor) }
      if (row.entC_FecBloqueoProveedor) { this.groupPoppupB.get('fechabloqueoo').setValue(new Date(row.entC_FecBloqueoProveedor)) }
      if (row.entC_ObsBloqueoProveedor) { this.groupPoppupB.get('comentariobloqueo').setValue(row.entC_ObsBloqueoProveedor) }
    }
  }
  uploadedFiles: any[] = [];
  onUpload(event) {
    if (event.files.length > 0) {
      for (let file of event.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64Data = (e.target.result as string).split(',')[1];
          const req = {
            items: [{
              codigo: 0,
              tipotran: 'I',
              image: URL.createObjectURL(file),
              usuario: this.storage.get('usuario'),
              fecha: this.util.formatearfecha(new Date(), 'dd-mm-yyyy'),
              nombre: file.name,
              url: base64Data
            }]
          }
          const isDuplicate = this.uploadedFiles.some(f =>
            f.nombre === req.items[0].nombre &&
            f.url === req.items[0].url &&
            f.tipotran !== 'D' // Solo se considera duplicado si **NO** tiene tipotran 'D'
          );

          if (!isDuplicate) {
            this.uploadedFiles.push({
              codigo: req.items[0].codigo,
              tipotran: req.items[0].tipotran,
              image: req.items[0].image,
              usuario: req.items[0].usuario,
              fecha: req.items[0].fecha,
              nombre: req.items[0].nombre,
              url: req.items[0].url
            });

            this.uploadedFiles = [...this.uploadedFiles]
          }


        }
        reader.readAsDataURL(file);
      }
    }
  }

  obtenerIconoTipoArchivo(nombreArchivo: string): string {
    const extension = nombreArchivo.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return '../../../../../assets/iconos/pdf.svg';
      case 'doc':
        return '../../../../../assets/iconos/documento.svg'
      case 'docx':
        return '../../../../../assets/iconos/word.svg'
      case 'jpg':
        return '../../../../../assets/iconos/jpg.svg'
      case 'jpeg':
      case 'png':
        return 'assets/icons/image-icon.svg';
      case 'xls':
        return '../../../../../assets/iconos/excel.svg'
      case 'xlsx':
        return '../../../../../assets/iconos/excel.svg'
      default:
        return 'assets/icons/default-icon.svg';
    }
  }

  downloadArchivo(value, row: any) {
    if (!row.url) {
      console.error('No hay archivo disponible para descargar.');
      return;
    }
    const extension = row.nombre.split('.').pop();
    const mimeType = this.getMimeType(extension);
    const fileName = `${row.nombre}.${extension}`;

    const byteCharacters = atob(row.url);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  getMimeType(extension: string): string {
    const mimeTypes: { [key: string]: string } = {
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'pdf': 'application/pdf',
      'txt': 'text/plain',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'zip': 'application/zip',
    };

    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }

  deleteArchivo(row) {
    if (row) { row.tipotran = 'D'; }
  }

  verHistorial(value, row: any) {
    const Request: ListarHistorialRequest = <ListarHistorialRequest>{}
    Request.pintENTC_Codigo = this.entcCod
    Request.psinTIPE_Codigo = 2
    Request.pchrTIPO_TabMND = row.tipO_TabMND
    Request.pchrTIPO_CodMND = row.tipO_CodMND
    this.dataTableHistorial = []
    this.mantcomercial.ListarHistorialEntidad(Request).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableHistorial = response.datos.result }
    })
  }
  ListaTranEntidad: TablaEntidadBloqueo[] = []
  ListaTranDirecEntidad: TablaDireccionEntidad[] = []
  async TransaccionEntidad(accion, row) {
    const tnsValida = await this.validarTransaccion();
    const emailValido = await this.validarEmail();
    const direccionValida = await this.validarDirecciones();
    if ((tnsValida == false || emailValido == false || direccionValida == false) && accion !== 'D') { return; }

    const values = this.groupPoppupDG.value
    const valuesdatos = this.groupPoppupD.value
    const valuesbloqueo = this.groupPoppupB.value
    const RequestTrans: TransaccionEntidadBloqueoRequest = <TransaccionEntidadBloqueoRequest>{}
    RequestTrans.tablaDireccionEntidad = []
    const items = <TablaDireccionEntidad>{}
    items.ENTC_Codigo = this.entcCod || 0
    if (accion === 'I') {
      items.DIRE_Codigo = 0
    } else { items.DIRE_Codigo = 1 }
    items.DIRE_Direccion = values.direccion
    items.DIRE_Facturar = true
    items.DIRE_Referencia = null
    items.DIRE_Activo = true
    items.UBIG_Codigo = values.distrito
    items.TIPO_TabPais = 'PAI'
    items.TIPO_CodPais = values.pais
    items.AUDI_UsrCrea = this.storage.get('usuario')
    items.AUDI_UsrMod = this.storage.get('usuario')
    if (accion === 'I') {
      items.tipotran = 'I';
    } else if (accion === 'U') {
      if (values.direccion) {
        const direccionEnBD = this.dataTableDireccion.some(row => row && row.dirE_Codigo === 1);
        if (!direccionEnBD) {
          items.tipotran = 'I';
        } else {
          items.tipotran = 'U';
        }
      } else {
        items.tipotran = 'D';
      }
    }
    RequestTrans.tablaDireccionEntidad.push(items)
    RequestTrans.tablaEntidadBloqueo = []
    const itement = <TablaEntidadBloqueo>{}
    itement.ENTC_Codigo = this.entcCod || 0
    itement.TIPO_TabTDI = 'TDI'
    itement.TIPO_CodTDI = values.tipodocumento
    itement.ENTC_TipEnt = values.tipopersona
    itement.ENTC_DocIden = values.numerodocumento
    itement.ENTC_Domiciliado = values.nodomiciliado == null ? false : values.nodomiciliado
    itement.ENTC_Nombres = values.nombres
    itement.ENTC_ApePat = values.apellidopaterno
    itement.ENTC_ApeMat = values.apellidomaterno
    if (values.apellidopaterno && values.nombres) {
      itement.ENTC_NomCompleto = `${itement.ENTC_ApePat || ''} ${itement.ENTC_ApeMat || ''} ${itement.ENTC_Nombres || ''}`.trim();
    } else if (values.razoncomercial) {
      itement.ENTC_NomCompleto = values.razoncomercial;
    } else if (values.razonsocial) {
      itement.ENTC_NomCompleto = values.razonsocial;
    } else { itement.ENTC_NomCompleto = null }
    itement.ENTC_NomComercial = values.razoncomercial
    itement.ENTC_RazonSocial = values.razonsocial
    itement.ENTC_Activo = values.activo || false
    itement.ENTC_FecNac = values.fechanacimiento
    itement.ENTC_FecIng = values.fechaingreso
    itement.ENTC_VIP = values.vip == null ? false : values.vip
    itement.ENTC_Notas = this.row['entC_Notas'] || null
    itement.ENTC_Sexo = values.sexo
    itement.ENTC_EMail = values.correo
    itement.ENTC_Web = this.row['entC_Web'] || null
    itement.ENTC_Propio = this.row['entC_Propio'] || false
    itement.ENTC_Telef1 = this.row['entC_Telef1'] || null
    itement.ENTC_Telef2 = this.row['entC_Telef2'] || null
    itement.ENTC_Telef3 = null
    itement.ENTC_Telef4 = null
    itement.ENTC_Beneficiario = this.row['entC_Beneficiario'] || null
    itement.ENTC_Area = values.area
    itement.ENTC_Cargo = values.cargo
    itement.USER_CodUsr = this.row['useR_CodUser'] || null
    itement.TIPO_TabPai = 'PAI'
    itement.TIPO_CodPai = values.pais
    itement.TIPO_TabHol = this.row['tipO_TabHol'] || null
    itement.TIPO_CodHol = this.row['tipO_CodHol'] || null
    itement.CONS_CodTFT = this.row['conS_CodTFT'] || null
    itement.CONS_TabTFT = this.row['conS_TabTFT'] || null
    itement.TIPO_TabCiu = this.row['tipO_TabCiu'] || null
    itement.TIPO_CodCiu = this.row['tipO_CodCiu'] || null
    itement.ENTC_Prospecto = values.prospecto || false
    itement.TIPO_TabDTM = this.row['tipO_TabDTM'] || null
    itement.TIPO_CodDTM = this.row['tipO_CodDTM'] || null
    itement.ENTC_ValRebate = this.row['entC_ValRebate'] || null
    itement.TIPO_TabMnd = this.row['tipO_TabMnd'] || null
    itement.TIPO_CodMnd = this.row['tipO_TabMnd'] || null
    itement.ENTC_ValTarja = this.row['entC_ValTarja'] || null
    itement.ENTC_DiasCredito = values.diascreditos ?? 0
    // itement.ENTC_FechaCredito = values.fechacredito
    itement.ENTC_Tarja = this.row['entC_Tarja'] || false
    itement.ENTC_CodAduana = this.row['entC_CodAduana'] || null
    itement.CONS_CodCre = this.row['conS_CodCre'] || null
    itement.CONS_TabCre = this.row['conS_CodCre'] || null
    itement.ENTC_EMail2 = this.row['entC_EMail2'] || false
    itement.ENTC_Obser = values.observaciones
    itement.ENTC_InterbancarioSol = valuesdatos.ctaintersoles
    itement.ENTC_InterbancarioDol = valuesdatos.ctainterdolares
    itement.ENTC_CuentaDetraccion = valuesdatos.ctadetracciones
    itement.ENTC_ServicioLogistico = this.row['entC_ServicioLogistico'] || false
    itement.ENTC_OcultarShipper = this.row['entC_OcultarShipper'] || false
    itement.ENTC_ObsFinanzasCliente = this.row['entC_ObsFinanzasCliente'] || null
    itement.ENTC_BloqueoFinanzasCliente = this.row['entC_BloqueoFinanzasCliente'] || false
    itement.ENTC_UsrBloqueoCliente = this.row['entC_UsrBloqueoCliente'] || null
    itement.ENTC_FecBloqueoCliente = this.row['entC_FecBloqueoCliente'] || null
    itement.ENTC_EmailFinanzas = valuesdatos.correofinanzas
    itement.ENTC_ObsBloqueoCliente = this.row['entC_ObsBloqueoCliente'] || null
    itement.ENTC_OtrosTraficos = this.row['entC_OtrosTraficos'] || false
    itement.ENTC_Mandato = this.row['entC_Mandato'] || false
    itement.ENTC_SLI = this.row['entC_SLI'] || false
    itement.ENTC_Exportacion = this.row['entC_Exportacion'] || false
    itement.ENTC_UsrBloqueoProveedor = valuesbloqueo.usuariobloqueo
    itement.ENTC_FecBloqueoProveedor = valuesbloqueo.fechabloqueoo
    itement.ENTC_BloqueoFinanzasProveedor = valuesbloqueo.bloqueado || false
    itement.ENTC_ObsFinanzasProveedor = this.row['entC_ObsFinanzasProveedor'] || null
    itement.ENTC_ObsBloqueoProveedor = valuesbloqueo.comentariobloqueo
    itement.ENTC_ProvAsumeDetraccion = valuesdatos.asumedetraccion || false
    itement.ENTC_ToOrder = this.row['entC_ToOrder'] || false
    itement.AUDI_UsrCrea = this.storage.get('usuario')
    itement.AUDI_UsrMod = this.storage.get('usuario')
    itement.ENTC_EmailReceptorFE = this.row['entC_EmailReceptorFE'] || null
    itement.TIPO_CodSEG = this.row['entC_CodSEG'] || null
    itement.ENTC_NombreContacto = values.contactonombre
    itement.ENTC_ApellidoContacto = values.contactoapellidos
    itement.ENTC_CorreoContactoExpo = values.correoexport
    itement.nombreGerente = values.nomgerente
    itement.fechaNacimiento = values.fechanacimientog
    itement.fechaAniversario = values.fechaAniversariog
    itement.ENTC_Siglas = this.row['entc_siglas'] || null

    RequestTrans.tablaEntidadBloqueo.push(itement)
    RequestTrans.TIPE_Codigo = 2
    RequestTrans.DIRE_Facturar = true
    RequestTrans.ENTC_Codigo = row.entC_Codigo != null ? row.entC_Codigo : values['codigo']
    RequestTrans.operacion = accion

    RequestTrans.tablaserviciosentidad = [];
    RequestTrans.tabladetalleservicio = [];
    RequestTrans.tablazonatransporte = [];
    RequestTrans.tablatipocarga = [];
    RequestTrans.tablaEntidadRelacionados = [];

    this.dataTableCuentasBancarias = this.dataTableCuentasBancarias.map(item => ({
      tipotran: item.ESTADO_OBJ || 'U',
      ENTC_Codigo: this.entcCod,
      TIPO_TabBCO: 'BCO',
      TIPO_CodBCO: item.tipO_CodBCO ? item.tipO_CodBCO : item.tipO_BCO?.value,
      tipO_BCO: item.tipO_BCO?.label,
      ENCB_TipoCuenta: item.encB_TipoCuenta ? item.encB_TipoCuenta : item.tipoCuenta?.value,
      tipoCuenta: item.tipoCuenta?.label || item.encB_TipoCuenta,
      ENCB_NroCuentaSol: item.encB_NroCuentaSol,
      ENCB_NroCuentaDol: item.encB_NroCuentaDol,
      AUDI_UsrCrea: this.storage.get('usuario'),
      AUDI_UsrMod: this.storage.get('usuario')
    }));

    RequestTrans.tablacuentasbancarias = this.dataTableCuentasBancarias

    this.InsertLimCredito = this.dataTableLimiteCredito.map(item => ({
      ENTC_Codigo: this.entcCod,
      TIPE_Codigo: this.codigoEntidad,
      ENLI_Tipos: "PRO",
      ENLI_Codigo: item.enlI_Codigo,
      ENLI_Monto: item.enlI_Monto || 0,
      ENLI_DiasDuracion: values.diascreditos ?? 0,
      // ENLI_Fecha: values.fechacredito,
      ENLI_Notas: item.enlI_Notas,
      ENLI_FecInicio: new Date(item.enlI_FecInicio) || null,
      ENlI_FecVencimiento: new Date(item.enlI_FecVencimiento) || null,
      ENLI_FormaPago: item.enlI_FormaPagoDescripcion?.value,
      TIPO_TabMND: 'MND',
      TIPO_CodMND: item.tipO_MND?.value,
      AUDI_UsrCrea: this.storage.get('usuario'),
      AUDI_UsrMod: this.storage.get('usuario'),
      ENLI_TipoFecVencimiento: null,
      ENLI_CliAutEmiCheqDiferidos: false,
      ENLI_CliConCredLibre: false,
      tipotran: item.enlI_Codigo != null ? item.ESTADO_OBJ : 'I'
    }))

    RequestTrans.tablalimitecredito = this.InsertLimCredito

    this.InsertArchivos = this.uploadedFiles.map(item => ({
      ENAR_Codigo: item.codigo,
      ENTC_Codigo: this.entcCod,
      ENAR_Archivo: item.url,
      AUDI_UsrCrea: item.usuario,
      ENAR_NombreArchivo: item.nombre,
      ENAR_Extension: '.' + item.nombre.split('.').pop(),
      ID_OUT: 0,
      tipotran: item.tipotran
    }))

    RequestTrans.tablaarchivosentidad = this.InsertArchivos


    // John 12/05/2025



    const datosserviciosproveedor = []
    this.dtS.forEach(r => {
      const item = <TablaEntidadDetalleServicio>{
        dser_activo: r.dseR_activo,
        dser_critico: r.dseR_Critico,
        empr_codigo: 1,
        entc_codigo: r.entC_Codigo,
        serv_codigo: r.serV_Codigo,
        sucr_codigo: 1,
        usua_usuario: r.audI_UsrCrea,
        cons_tabrgm: 'RGM',
        cons_tabvia: 'VIA',
        cons_tablng: 'LNG',
        cons_codrgm: r.conS_CodRGM,
        cons_codvia: r.conS_CodVIA,
        cons_codlng: r.conS_CodLNG,
        dser_codigo: 1,
        estado_obj: 'I'

      }
      datosserviciosproveedor.push(item)
    })
    RequestTrans.tabladetalleservicio = datosserviciosproveedor

    const datoszonatransporte = []
    this.TableZonaTransporte.forEach(r => {
      const item = <TablaEntidadZonaTransporte>{
        empr_codigo: 1,
        entc_codigo: r.entC_Codigo,
        enzt_activo: true,
        enzt_coddepartamento: r.enzT_CodDepartamento,
        enzt_codprovincia: r.enzT_CodProvincia,
        enzt_coddistrito: r.enzT_CodDistrito,
        sucr_codigo: 1,
        usua_usuario: r.audI_UsrCrea,
        estado_obj: 'I',
        enzt_codigo: 0
      }
      datoszonatransporte.push(item)
    })
    RequestTrans.tablazonatransporte = datoszonatransporte

    const datostipocarga = []
    this.dtT.forEach(r => {
      const item = <TablaEntidadTipoCarga>{
        etcg_codigo: 0,
        cons_tabtcr: "TCR",
        cons_codtcr: r.conS_CodTCR,
        empr_codigo: 1,
        sucr_codigo: 1,
        entc_codigo: r.entC_Codigo,
        etcg_activo: true,
        usua_usuario: r.audI_UsrCrea,
        estado_obj: 'I'

      }
      datostipocarga.push(item)
    })
    RequestTrans.tablatipocarga = datostipocarga

    if (accion === 'D') {


      this.confirmationService.confirm({
        target: event.target as EventTarget,
        message: 'Estas surguro en eliminar este proveedor?',
        header: 'Confirmation',
        closable: true,
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectButtonProps: {
          label: 'Cancelar',
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: 'Eliminar',
        },
        accept: () => {
          this.mantcomercial.TransaccionEntidadBloqueo(RequestTrans).subscribe(response => {
            if (response.datos.status === 200) {
              this.util.ShowMessage({ titulo: '', mensaje: 'Se eliminaron los datos correctamente.', tipo: 'ok' })
              this.search()
            }
          })

        },
        reject: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Rejected',
            detail: 'You have rejected',
            life: 3000,
          });
        },
      });

    } else {
      // if (values.diascreditos) {
      this.mantcomercial.TransaccionEntidadBloqueo(RequestTrans).subscribe(response => {
        if (response.datos.status === 200) {
          this.util.ShowMessage({ titulo: '', mensaje: response?.meta?.mensaje, tipo: 'ok' })
          this.visible = false
          this.search()
        }
      })
      // } else {
      //   this.messageService.clear();
      //   this.messageService.add({ key: 'toast3', severity: 'error', summary: 'Error', detail: 'Falta completar Días Crédito.' });
      // }
    }
  }


  deleteServicio(row: any) {
    row.tipotran = 'D';
    this.dtS = this.dtS.filter(item => item.id !== row.id);
  }

  deleteTransporte(row: any) {
    row.tipotran = 'D';
    this.TableZonaTransporte = this.TableZonaTransporte.filter(item => item.id !== row.id);
  }

  deleteRow(row: any) {
    row.tipotran = 'D'; // Marcar antes de eliminar visualmente
    this.dtT = this.dtT.filter(item => item.conS_CodTCR !== row.conS_CodTCR);
  }



  exportExcel() {
    if (this.dataTable.length == 0) { this.util.showMessageError('No hay datos para exportar'); return; }
    let nuevadata = []
    this.dataTable.forEach(row => {
      const {
        entC_Codigo,
        tipO_CodTDI,
        entC_DocIden,
        entC_RazonSocial,
        entC_Activo,
        entC_EMail,
        entC_EmailReceptorFE,
        entC_Telef1,
        entC_Telef2,
        entC_CodSAP_C,
        entC_CodSAP_P,
        entC_FecActSAP,
        audI_UsrCrea,
        audI_FecCrea,
        audI_UsrMod,
        audI_FecMod
      } = row;
      const newItem = {
        "CÓDIGO": entC_Codigo,
        "TIPO DOC. IDENTIDAD": tipO_CodTDI,
        "N.I.T": entC_DocIden,
        "NOMBRE": entC_RazonSocial,
        "ACTIVO": entC_Activo === true ? 'SI' : 'NO',
        "CORREO": entC_EMail,
        "CORREO FACTURA ELECTRÓNICA": entC_EmailReceptorFE,
        "TEL. FIJO": entC_Telef1,
        "TEL. MÓVIL": entC_Telef2,
        "CLIENTE SAP": entC_CodSAP_C,
        "PROVEEDOR SAP": entC_CodSAP_P,
        "SINCRONIZACIÓN SAP": this.util.formatearfecha(entC_FecActSAP, 'dd-mm-yyyy'),
        "CREADO POR": audI_UsrCrea,
        "FECHA CREA": this.util.formatearfecha(audI_FecCrea, 'dd-mm-yyyy'),
        "MODIFICADO POR": audI_UsrMod,
        "FECHA MOD.": this.util.formatearfecha(audI_FecMod, 'dd-mm-yyyy')
      };
      nuevadata.push(newItem);
    });

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'MANTENIMIENTO PROVEEDORES.xlsx')
  }

  salir(event: Event) {
    // this.visible = false
    // this.dtS = []
    // this.dtT = []
    // this.TableZonaTransporte = []
    // this.groupOD.reset()
    // this.groupPS.reset()
    // this.groupPoppupDG.reset()  

    // this.confirmationService.confirm({
    //   target: event.target as EventTarget,
    //   message: 'Estas Seguro de salir?',
    //   header: 'Confirmation',
    //   closable: true,
    //   closeOnEscape: true,
    //   icon: 'pi pi-exclamation-triangle',
    //   rejectButtonProps: {
    //     label: 'Cancelar',
    //     severity: 'secondary',
    //     outlined: true,
    //   },
    //   acceptButtonProps: {
    //     label: 'Salir',
    //   },
    //   accept: () => {
    this.visible = false
    this.dtS = []
    this.dtT = []
    this.TableZonaTransporte = []
    this.groupOD.reset()
    this.groupPS.reset()
    this.groupPoppupDG.reset()

    //   },
    //   reject: () => {
    //     this.messageService.add({
    //       severity: 'error',
    //       summary: 'Rejected',
    //       detail: 'You have rejected',
    //       life: 3000,
    //     });
    //   },
    // });

  }

  verNumDoc(event) {
    if (event.value === '002') {
      this.groupPoppupDG.get('tipopersona').setValue("N")
      this.visiblenumdoc = true
    }
    else if (event.value === '004') { this.visiblenumdoc = false } else { this.visiblenumdoc = true }
  }

  salirBandejaPrincipal() {
    const rutaComponente = '/mantenimiento-comercial';
    this.router.navigate([rutaComponente]);
  }

  sincronizarSAP(row) {
    this.funcionSincronizarSAP(row.row, 'P')
  }
  //   deleteRow(row) {

  // }

  funcionSincronizarSAP(row: any, tipoSocio: string) {
    this.metadataTable[0].loading = true;
    const loadingScreen = this.util.showLoadingScreen({ message: "Sincronizando ..." });
    const Request: SincronizarEntidadSapRequest = <SincronizarEntidadSapRequest>{}
    Request.ENTC_Codigo = row.entC_Codigo
    Request.TIPE_Codigo = row.tipE_Codigo
    Request.TipoSocio = tipoSocio
    this.mantcomercial.SincronizarEntidadSAP(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.util.ShowMessage({ titulo: "Sincronización Exitosa", mensaje: response.meta.mensajeRespuesta, icono: "OK", tipo: "ok" });
        this.metadataTable[0].loading = false;
        this.search();
        loadingScreen.close();
      } else {
        this.util.ShowMessage({ titulo: "ERROR", mensaje: response.meta.mensajeRespuesta, icono: "pi pi-exclamation-triangle", tipo: "warning" });
        this.metadataTable[0].loading = false;
        loadingScreen.close();
      }
    }, err => {
      this.util.ShowMessage({ titulo: "ERROR", mensaje: err?.error?.meta?.mensaje, icono: "pi pi-exclamation-triangle", tipo: "warning" });
      loadingScreen.close();
      this.metadataTable[0].loading = false;
    })
  }

  InsertArchivos: any[] = []
  dataButtons = [
    { icon: 'pi pi-download', function: () => this.exportAuditoria() }
  ];
  exportAuditoria() {
    if (this.dataTableAuditoria.length == 0) { this.util.showMessageError('No hay datos para exportar'); return; }
    let nuevadata = []
    this.dataTableAuditoria.forEach(row => {
      const {
        operacion,
        direccionip,
        nombremaquina,
        nombreaplicacion,
        usuariosql,
        usuarioaplicacion,
        fechamodificacion,
        codigoentidad,
        docidentidad,
        codigodocidentidad,
        numdocidentidad,
        tipopersona,
        domiciliado,
        nombres,
        apellidopaterno,
        apellidomaterno,
        nombrecompleto,
        nombrecomercial,
        razonsocial,
        activo,
        fechanacimiento,
        fechaingreso,
        vip,
        notas,
        sexo,
        email,
        email2,
        web,
        propio,
        telefono1,
        telefono2,
        telefono3,
        telefono4,
        beneficiario,
        area,
        cargo,
        cuentausuario,
        pais,
        codigopais,
        holding,
        codigoholding,
        tipotarifa,
        codigotarifa,
        prospecto,
        rebate,
        moneda,
        codigomoneda,
        tipodeposito,
        codtipodeposito,
        tarja,
        realizatarja,
        diacredito,
        // fechacredito,
        codigoaduana,
        observaciones,
        cuenintersoles,
        cueninterdolares,
        cuendetraccion,
        serviciologistico,
        ocultarshipper,
        obserfinanzas,
        otrostraficos,
        mandato,
        sli,
        exportacion,
        emailfinanzas,
        bloqueocliente,
        usubloqueacliente,
        fecbloqueocliente,
        obserbloqueocliente,
        bloqueoproveedor,
        usubloqueaproveedor,
        fecbloqueoproveedor,
        obserbloqueoproveedor,
        obserproveedor,
        asumedetraccion,
        usuariocrea,
        fechacrea,
        usuariomodifica,
        fechamodifica
      } = row;
      const newItem = {
        "Operación": operacion,
        "Dirección IP": direccionip,
        "Nombre Máquina": nombremaquina,
        "Nombre Apliación": nombreaplicacion,
        "Usuario SQL": usuariosql,
        "Usuario Aplicación": usuarioaplicacion,
        "Fecha Modificación": fechamodificacion || '',
        "Código Entidad": codigoentidad || '',
        "Doc. Identidad": docidentidad || '',
        "Código Doc. Identidad": codigodocidentidad || '',
        "Num. Doc. Identidad": numdocidentidad || '',
        "Tipo Persona": tipopersona || '',
        "Domiciliado": domiciliado === true ? 'SI' : 'NO',
        "Nombres": nombres || '',
        "Ape. Paterno": apellidopaterno || '',
        "Ape. Materno": apellidomaterno || '',
        "Nom. Completo": nombrecompleto || '',
        "Nom. Comercial": nombrecomercial || '',
        "Razón Social": razonsocial || '',
        "Activo": activo === true ? 'SI' : 'NO',
        "Fec. Nacimiento": fechanacimiento,
        "Fec. Ingreso": fechaingreso,
        "VIP": vip === true ? 'SI' : 'NO',
        "Notas": notas,
        "Sexo": sexo,
        "E-mail": email,
        "E-mail2": email2,
        "Web": web,
        "Propio": propio,
        "Teléfono 1": telefono1,
        "Teléfono 2": telefono2,
        "Teléfono 3": telefono3,
        "Teléfono 4": telefono4,
        "Beneficiario": beneficiario,
        "Área": area,
        "Cargo": cargo,
        "Cuenta Usuario": cuentausuario,
        "País": pais,
        "Cod. País": codigopais,
        "Holding": holding,
        "Cod. Holding": codigoholding,
        "Tipo Tarifa": tipotarifa,
        "Cod. Tarifa": codigotarifa,
        "Prospecto": prospecto === true ? 'SI' : 'NO',
        "Rebate": rebate,
        "Moneda": moneda,
        "Cod. Moneda": codigomoneda,
        "Tipo Depósito": tipodeposito,
        "Cod. Tipo Depósito": codtipodeposito,
        "Tarja": tarja,
        "Reaiza Tarja": realizatarja === true ? 'SI' : 'NO',
        "Día Crédito": diacredito,
        // "Fec. Crédito": fechacredito,
        "Cod. Aduana": codigoaduana,
        "Observaciones": observaciones,
        "Cuen. Inter. Soles": cuenintersoles,
        "Cuen. Inter. Dólares": cueninterdolares,
        "Cuen. Detracción": cuendetraccion,
        "Servicio Logístico": serviciologistico === true ? 'SI' : 'NO',
        "Ocultar Shipper": ocultarshipper === true ? 'SI' : 'NO',
        "Obser. Finanzas": obserfinanzas,
        "Otros Tráficos": otrostraficos === true ? 'SI' : 'NO',
        "Mandato": mandato === true ? 'SI' : 'NO',
        "SLI": sli === true ? 'SI' : 'NO',
        "Exportación": exportacion === true ? 'SI' : 'NO',
        "E-mail Finanzas": emailfinanzas,
        "Bloqueo Cliente": bloqueocliente === true ? 'SI' : 'NO',
        "Usu. Bloquea Cliente": usubloqueacliente,
        "Fec. Bloqueo Cliente": fecbloqueocliente,
        "Obser. Bloqueo Cliente": obserbloqueocliente,
        "Bloqueo Proveedor": bloqueoproveedor === true ? 'SI' : 'NO',
        "Usu. Bloquea Proveedor": usubloqueaproveedor,
        "Fec. Bloqueo Proveedor": fecbloqueoproveedor,
        "Obser. Bloqueo Proveedor": obserbloqueoproveedor,
        "Obser. Proveedor": obserproveedor,
        "Asume Detracción": asumedetraccion,
        "Usuario Crea": usuariocrea,
        "Fec. Crea": fechacrea,
        "Usuario Modifica": usuariomodifica,
        "Fec. Modifica": fechamodifica
      };
      nuevadata.push(newItem);
    });

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'AUDITORÍA PROVEEDOR.xlsx')
  }

  async validarTransaccion(): Promise<boolean> {
    let esValido = true;
    let mensajeError = "";

    const group = this.groupPoppupDG;
    const get = (campo: string) => group.get(campo)?.value;

    let controles = {
      // ENTC_Codigo: { requerido: get("ENTC_Codigo") == null, mensaje: "Debe ingresar el campo ENTC_Codigo" },
      TIPO_CodTDI: { requerido: !get("tipodocumento"), mensaje: "Debe seleccionar el campo tipo documento" },
      ENTC_TipEnt: { requerido: !get("tipopersona"), mensaje: "Debe ingresar el campo Tipo de Persona" },
      ENTC_DocIden: { requerido: !get("numerodocumento"), mensaje: "Debe ingresar el campo número de documento" },
      // ENTC_Domiciliado: { requerido: get("nodomiciliado") == null, mensaje: "Debe ingresar el campo No Domiciliado" },
      // ENTC_VIP: { requerido: get("vip") == null, mensaje: "Debe ingresar el campo VIP" },
    };

    if (this.natural) {
      const ctlr = { ENTC_Sexo: { requerido: !get("sexo"), mensaje: "Debe ingresar el campo Sexo" } };
      controles = { ...controles, ...ctlr };
    }

    // Validar campos básicos
    for (let campo in controles) {
      if (controles[campo].requerido) {
        group.get(campo)?.setErrors({ required: true });
        mensajeError += `* ${controles[campo].mensaje}\n`;
        esValido = false;
      } else {
        group.get(campo)?.setErrors(null);
      }
    }

    // Validar según tipo de entidad
    const tipEnt = get("tipopersona");
    if (tipEnt === "J") {
      if (!get("razonsocial")) {
        group.get("razonsocial")?.setErrors({ required: true });
        mensajeError += "* Debe ingresar el campo razón social\n";
        esValido = false;
      } else {
        group.get("razonsocial")?.setErrors(null);
      }
    } else {
      if (!get("nombres")) {
        group.get("nombres")?.setErrors({ required: true });
        mensajeError += "* Debe ingresar el campo nombre\n";
        esValido = false;
      } else {
        group.get("nombres")?.setErrors(null);
      }
    }

    // Validar crédito
    const diasCredito = get("diascreditos");
    const fechaCredito = get("fechacredito");

    if (diasCredito && diasCredito > 0 && !fechaCredito) {
      group.get("fechacredito")?.setErrors({ required: true });
      mensajeError += "* Debe ingresar el campo fecha crédito\n";
      esValido = false;
    } else {
      group.get("fechacredito")?.setErrors(null);
    }

    if (!diasCredito && fechaCredito) {
      group.get("diascreditos")?.setErrors({ required: true });
      mensajeError += "* Debe ingresar el campo días crédito\n";
      esValido = false;
    } else {
      group.get("diascreditos")?.setErrors(null);
    }

    if (!esValido) {
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Completar campos obligatorios', detail: mensajeError });
    }

    return esValido;
  }

  async validarEmail(): Promise<boolean> {
    let l_correcto = true;
    let l_email1OK = true;
    let l_email2OK = true;
    let l_email3OK = true;

    let mensajeError = '';
    const delimiter = ';';

    // Validación de ENTC_EMail
    const ENTC_EMail = this.groupPoppupDG.get('correo')?.value;
    mensajeError = '';
    if (ENTC_EMail) {
      const correos = ENTC_EMail.split(delimiter);
      for (const correo of correos) {
        if (correo.trim() && !this.isValidEmail(correo.trim())) {
          l_email1OK = false;
        }
      }
      if (!l_email1OK) {
        mensajeError = 'El Formato del Correo es Incorrecto';
      }
    }

    // Validación de ENTC_EMail2
    // this.groupPoppupDG.ENTC_EMail2MSGERROR = '';
    // if (this.groupPoppupDG.ENTC_EMail2) {
    //   const correos2 = this.groupPoppupDG.ENTC_EMail2.split(delimiter);
    //   for (const correo of correos2) {
    //     if (correo.trim() && !this.isValidEmail(correo.trim())) {
    //       l_email2OK = false;
    //     }
    //   }
    //   if (!l_email2OK) {
    //     this.groupPoppupDG.ENTC_EMail2MSGERROR = 'El Formato del Correo es Incorrecto';
    //   }
    // }

    // Validación de ENTC_EmailReceptorFE
    const ENTC_EmailReceptorFE = this.groupPoppupDG.get('correo_facturacion')?.value;
    if (ENTC_EmailReceptorFE) {
      const correos3 = ENTC_EmailReceptorFE.split(delimiter);
      for (const correo of correos3) {
        if (correo.trim() && !this.isValidEmail(correo.trim())) {
          l_email3OK = false;
        }
      }
      // Puedes habilitar este mensaje si tienes un campo específico para mostrarlo
      // if (!l_email3OK) {
      //   this.groupPoppupDG.ENTC_EmailReceptorFEMSGERROR = 'El Formato del Correo es Incorrecto';
      // }
    }

    if (!l_email1OK || !l_email2OK || !l_email3OK) {
      l_correcto = false;
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'El Formato de alguno de los correos ingresados es incorrecto', detail: mensajeError });
    }

    return l_correcto;
  }

  isValidEmail(emailList: string): boolean {
    const trimmed = (emailList || '').trim();
    if (!trimmed) return false;
    const emails = trimmed
      .split(/[\s,;]+/)
      .map(e => e.trim())
      .filter(e => e.length > 0);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emails.every(e => emailRegex.test(e));
  }

  validarDirecciones(): boolean {
    let l_correcto = true;
    let l_direccionFiscal = true;
    let l_direccionComercial = true;
    let mensajeError = '';

    const DIRE_Direccion = this.groupPoppupDG.get('direccion')?.value;
    const pais = this.groupPoppupDG.get('pais')?.value;

    if (pais) {
      if (!DIRE_Direccion) {
        l_direccionFiscal = false;
      }
    }

    // if (this.groupPoppupDG.TIPO_TabPaisFiscal && this.groupPoppupDG.TIPO_CodPaisFiscal) {
    //   if (!DIRE_Direccion) {
    //     l_direccionFiscal = false;
    //   }
    // }

    // if (this.groupPoppupDG.TIPO_TabPaisComercial && this.groupPoppupDG.TIPO_CodPaisComercial) {
    //   if (!this.groupPoppupDG.DIRE_DireccionComercial) {
    //     l_direccionComercial = false;
    //   }
    // }

    if (!l_direccionFiscal || !l_direccionComercial) {
      l_correcto = false;
      this.messageService.clear();
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Campos obligatorios', detail: 'Debe ingresar una Dirección para poder guardar el registro' });
    }

    return l_correcto;
  }

  multiEmailTrimmedValidator(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').trim();
    if (!value) return null;
    const emails = value
      .split(/[\s,;]+/)
      .map(email => email.trim())
      .filter(email => email.length > 0);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const allValid = emails.every(email => emailRegex.test(email));
    return allValid ? null : { email: true };
  }


  agregarServicio() {

    const datos = this.groupPS.value.servicios
    const LNG = this.groupPS.value.lineanegocio
    const RGM = this.groupPS.value.regimen
    const VIA = this.groupPS.value.via
    if (datos && Array.isArray(datos)) {
      const codigosYaAgregados = datos
        .map(r => r.codigo)
        .filter(cod => this.dtS.some(item => item.serV_Codigo === cod));

      if (codigosYaAgregados.length > 0) {
        console.warn('Algunos servicios ya fueron agregados:', codigosYaAgregados);
        return;
      }

      datos.forEach(r => {
        const item = {
          tipotran: 'I',
          dseR_Codigo: null,
          entC_Codigo: this.entcCod,
          serV_Codigo: r.codigo,
          servicio: r.nombre,
          dseR_Critico: false,
          dseR_activo: true,
          audI_UsrCrea: this.storage.get('usuario'),
          audI_FecCrea: new Date(),
          audI_UsrMod: null,
          audI_FecMod: null,
          conS_TabRGM: 'RGM',
          conS_TabVIA: 'VIA',
          conS_CodRGM: RGM,
          conS_CodVIA: VIA,
          conS_TabLNG: 'LNG',
          conS_CodLNG: LNG,
        }
        this.dtS.push(item)
      })


    }

    this.dtS = Array.from(this.dtS)
  }

  // agregarZonatransporte() {
  //   const datos = this.groupOD.value.provincia
  //   const datosD = this.groupOD.value.departamento
  //   if (datos) {
  //     const item = <zonaTransporte>{
  //       nombreDepartamento: datosD?.ubiG_Desc,
  //       nombreProvincia: datos?.ubiG_Desc,
  //       codigoDepartamento: datosD?.ubiG_Codigo,
  //       codigoProvincia: datos?.ubiG_Codigo
  //     }
  //     this.TableZonaTransporte.push(item)
  //   }
  //   this.TableZonaTransporte = Array.from(this.TableZonaTransporte)
  //   console.log(this.TableZonaTransporte)
  // }

  // agregarZonatransporte() {
  //   const datos = this.groupOD.value.provincia;
  //   console.log(datos);
  //   const datosD = this.groupOD.value.departamento;
  //   console.log(datosD);
  //   const datosI = this.groupOD.value.distrito;
  //   console.log(datosI)

  //   if (datos) {
  //     // Validación: evitar duplicados por código de departamento y provincia
  //     const yaExiste = this.TableZonaTransporte.some(item =>
  //       item.enzT_CodDepartamento === datosD?.ubiG_Codigo &&
  //       item.enzT_CodProvincia === datos?.ubiG_Codigo &&
  //       item.enzT_CodDistrito === datosI?.ubiG_Codigo
  //     );

  //     if (yaExiste) {
  //       console.warn('Esta combinación ya fue agregada.');
  //       return;
  //     }

  //     // Crear nuevo ítem con key única
  //     const item = {
  //       tipotran: 'I',
  //       enzT_Codigo: null,
  //       entC_Codigo: this.entcCod,
  //       enzT_CodDepartamento: datosD.ubiG_Codigo,
  //       enzT_CodProvincia: datos.ubiG_Codigo,
  //       enzT_CodDistrito: datosI.ubiG_Codigo,
  //       departamento: datosD.ubiG_Desc,
  //       provincia: datos.ubiG_Desc,
  //       distrito: datosI.ubiG_Desc,
  //       enzT_Activo: true,
  //       audI_UsrCrea: this.storage.get('usuario'),
  //       audI_FecCrea: new Date(),
  //       audI_UsrMod: null,
  //       audI_FecMod: null,
  //     };

  //     this.TableZonaTransporte.push(item);
  //   }

  //   this.TableZonaTransporte = Array.from(this.TableZonaTransporte);
  //   console.log(this.TableZonaTransporte);
  // }

  agregarZonatransporte() {
    const datos = this.groupOD.value.provincia;
    console.log(datos);
    const datosD = this.groupOD.value.departamento;
    console.log(datosD);
    const datosI = this.groupOD.value.distrito;
    console.log(datosI);

    if (datos) {
      // Validación: evitar duplicados por departamento, provincia y distrito (opcional)
      const yaExiste = this.TableZonaTransporte.some(item =>
        item.enzT_CodDepartamento === datosD?.ubiG_Codigo &&
        item.enzT_CodProvincia === datos?.ubiG_Codigo &&
        // Si no hay distrito seleccionado, se compara con null o vacío
        (
          (datosI && item.enzT_CodDistrito === datosI?.ubiG_Codigo) ||
          (!datosI && (item.enzT_CodDistrito === null || item.enzT_CodDistrito === ''))
        )
      );

      if (yaExiste) {
        console.warn('Esta combinación ya fue agregada.');
        return;
      }

      // Crear nuevo ítem, asignando null si no hay distrito seleccionado
      const item = {
        tipotran: 'I',
        enzT_Codigo: null,
        entC_Codigo: this.entcCod,
        enzT_CodDepartamento: datosD.ubiG_Codigo,
        enzT_CodProvincia: datos.ubiG_Codigo,
        enzT_CodDistrito: datosI ? datosI.ubiG_Codigo : null,
        departamento: datosD.ubiG_Desc,
        provincia: datos.ubiG_Desc,
        distrito: datosI ? datosI.ubiG_Desc : '',
        enzT_Activo: true,
        audI_UsrCrea: this.storage.get('usuario'),
        audI_FecCrea: new Date(),
        audI_UsrMod: null,
        audI_FecMod: null,
      };

      this.TableZonaTransporte.push(item);
    }

    this.TableZonaTransporte = Array.from(this.TableZonaTransporte);
    console.log(this.TableZonaTransporte);
  }


  ///___________________________________

  //   agregarTipoCarga() {

  //     const datos = this.groupOD.value.tipocarga
  //     console.log(datos)
  //     if (datos) {
  //       const item = <tipoCarga>{
  //         nombreTipoCarga: datos?.label,
  //         codigoTipoCarga: datos?.value
  //         key: `${datos?.value}-${Date.now()}`
  //       }
  //       this.dtT.push(item)
  //     }

  //     this.dtT = Array.from(this.dtT )
  //     console.log(this.dtT)
  //   }
  // }
  //____________________________
  agregarTipoCarga() {

    const datos = this.groupTC.value.tipocarga
    console.log(datos)
    if (datos) {
      const yaExiste = this.dtT.some(item =>
        item.conS_CodTCR === datos?.value
      );
      if (yaExiste) {
        console.warn('Esta combinación ya fue agregada.');
        return;
      }

      const item = {
        tipotran: 'I',
        etcG_Codigo: null,
        conS_TabTCR: 'TCR',
        conS_CodTCR: datos.value,
        etcG_Activo: true,
        tipocarga: datos.label,
        audI_UsrCrea: this.storage.get('usuario'),
        audI_FecCrea: new Date(),
        audI_UsrMod: null,
        audI_FecMod: null,
        entC_Codigo: this.entcCod,
      }
      this.dtT.push(item)
    }

    this.dtT = Array.from(this.dtT)
  }

  eliminar(row: any) {
    this.util.MessageDialog({
      titulo: 'Confirmación', mensaje: "¿Seguro que desea eliminar la entidad?", icono: "pi pi-exclamation-triangle", tipo: "warning",
      textoBtn: { textoBtnOpcion1: "Sí", textoBtnOpcion2: "No", },
      pregunta: { onAccept: () => { this.TransaccionEntidad('D', row); }, onReject: () => { return; } }
    })
    return;
  }
}
//_____________________________
interface zonaTransporte {
  codigoDepartamento: string
  nombreDepartamento: string
  codigoProvincia: string
  nombreProvincia: string
  codigoDistrito: string
  nombreDistrito: string
  key?: string
}

interface tipoCarga {
  nombreTipoCarga: string
  codigoTipoCarga: string
  key?: string
}

interface intfservicio {
  nombreServicio: string,
  codigoServicio: string,
}

